<template>
  <v-app id="inspire">
    <v-app-bar
      app
      clipped-left
      color="grey lighten-3"
      :dense="mobileFlg"
    >
      <v-app-bar-nav-icon
        color="indigo"
        @click.stop="drawer = !drawer"
      />
      <v-img
        v-if="!mobileFlg"
        class="mx-3"
        src="../images/weplat.png"
        max-height="45"
        max-width="102"
        @click="kengenDialog = true"
      />
      <v-toolbar-title
        v-if="!mobileFlg"
        style="color: #3F51B5"
      >
        クラウドフォルダー {{ header_env }}
      </v-toolbar-title>
      <v-spacer />

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            color="primary"
            v-on="on"
            @click="setMenuItems();"
          >
            <v-icon left>
              mdi-cogs
            </v-icon>
            各種設定
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="menuItem in menuItems"
            :key="menuItem.menuId"
            @click="menuFunc(menuItem.menuId)"
          >
            <v-list-item-title>{{ menuItem.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- ↓↓依頼一覧 -->
    <v-content
      v-if="contentNumber === 1"
      :style="resizeContent"
    >
      <v-col
        v-if="iraiListTitle === ''"
        cols="12"
        align="center"
      >
        <v-card-text class="title">
          フォルダーを選択してください
        </v-card-text>
      </v-col>
      <v-tabs
        v-if="iraiListTitle !== ''"
        v-model="mainTabs"
      >
        <v-tab>メッセージ一覧</v-tab>
      </v-tabs>
      <v-tabs-items v-model="mainTabs">
        <v-tab-item>
          <v-card>
            <v-card-title class="pa-1">
              <v-container
                class="py-1 mx-1 px-0"
                fluid
              >
                <v-row
                  dense
                  align="center"
                >
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="1"
                  >
                    <v-tooltip
                      v-if="iraiListTitle !== '' && deleteFilterFlg === false"
                      v-model="partTool3"
                      right
                      nudge-bottom="40"
                      :open-on-hover="false"
                      open-delay="2000"
                    >
                      <template v-slot:activator="{ off }">
                        <v-btn
                          color="primary"
                          @click="newIraiCreate();"
                          v-on="off"
                        >
                          新規作成
                        </v-btn>
                      </template>
                      <span>
                        <h3>← ステップ④</h3>
                        <br>「新規作成」ボタン押して
                        <br>新規作成画面を開き、
                        <br>顧問先への新規メッセージを作成します。
                      </span>
                    </v-tooltip>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="stateCheckbox"
                      class="mt-0 ml-8"
                      label="全ての状態を表示"
                      hide-details
                      :ripple="false"
                      :dense="mobileFlg"
                      style="margin-top:0px;"
                    />
                    <v-checkbox
                      v-model="mynameCheckbox"
                      class="mt-0 ml-8"
                      label="作成者が自分のみ表示"
                      hide-details
                      :ripple="false"
                      :dense="mobileFlg"
                      style="margin-top:0px;"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="endDateFrom"
                      type="date"
                      label="納期(From)"
                      clearable
                      :dense="mobileFlg"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="endDateTo"
                      type="date"
                      label="納期(To)"
                      clearable
                      :dense="mobileFlg"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="4"
                    style="padding-right:10px;"
                  >
                    <v-text-field
                      v-model="searchTable"
                      label="ここに入力して検索"
                      single-line
                      clearable
                      :dense="mobileFlg"
                      :disabled="disableSerchIraiList"
                      append-icon="mdi-magnify"
                      @click:append="serchIraiList();"
                      @click:clear="getIraiList();"
                    />
                  </v-col>
                </v-row>
                <v-row
                  dense
                  class="pl-2"
                >
                  {{ iraiListTitle }}
                </v-row>
              </v-container>
              <!-- ↓↓新規依頼作成ダイアログ -->
              <v-dialog
                v-model="newIraiDialog"
                max-width="500px"
                persistent
                scrollable
                :fullscreen="mobileFlg"
              >
                <v-card>
                  <v-card-title>
                    <span class="headline">新規作成</span>
                    <v-spacer />
                    <v-btn
                      icon
                      large
                      color="#3F51B5"
                      @click="close"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="height:80%;">
                    <v-container>
                      <v-row>
                        <v-form
                          ref="newIraiForm"
                          v-model="valid"
                          lazy-validation
                          style="width:100%"
                          @submit.prevent
                        >
                          <v-col
                            cols="12"
                            xs="12"
                            sm="12"
                            md="12"
                          >
                            <span>依頼先</span>
                            <v-card-text class="title pa-0">
                              {{ iraiListTitle }}
                            </v-card-text>
                          </v-col>
                          <v-col
                            cols="12"
                            xs="6"
                            sm="6"
                            md="6"
                          >
                            <v-text-field
                              v-model="editedItem.end"
                              label="納期(※)"
                              required
                              type="date"
                              :rules="[v => !!v || &quot;納期は必須です&quot;]"
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="editedItem.title"
                              label="タイトル(※)"
                              required
                              counter
                              maxlength="30"
                              :rules="[v => !!v || &quot;タイトルは必須です&quot;]"
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-textarea
                              v-model="editedItem.messages[0].message"
                              label="メッセージ"
                              outlined
                              clearable
                              auto-grow
                              counter
                              maxlength="500"
                            />
                          </v-col>
                          <v-col
                            v-if="!mobileFlg"
                            cols="12"
                            xs="12"
                            sm="12"
                            md="12"
                          >
                            <div
                              class="jumbotron jumbotron-extend"
                              style="width:-webkit-fill-available;"
                            >
                              <div class="container pa-0">
                                <div
                                  id="dropzone"
                                  effectAllowed="move"
                                  style="padding-right:20px;"
                                  @dragleave.prevent
                                  @dragover.prevent
                                  @drop.prevent="onDrop"
                                >
                                  ここにアップロードファイルをドラッグ＆ドロップ
                                </div>
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="12">
                            <v-file-input
                              v-model="uploadFiles"
                              multiple
                              counter
                              persistent-hint
                              :hint="'ファイル添付の制限は100ファイル（合計' + maxUploadBytesDisp + '）です。'"
                              placeholder="左のアイコンを押してファイル選択"
                              :show-size="1024"
                              :counter-size-string="'{0} ファイル (合計 ' + getAllFileSizeDisp(uploadFiles) + ')'"
                              prepend-icon="mdi-paperclip"
                              :rules="[v => getAllFileSize(v) <= maxUploadBytes || 'アップロード可能なのは合計'+ maxUploadBytesDisp +'までです',
                                       v => v.length <= 100 || &quot;アップロード可能なのは合計100ファイルまでです&quot;]"
                              @change="disableSave = false;"
                              @click:prepend="disableSave = false;"
                            >
                              <template v-slot:selection="{ index, text }">
                                <v-chip
                                  v-if="index < 100"
                                  small
                                  label
                                  color="primary"
                                >
                                  {{ text.replace(/iB\)/g, "B)") }}
                                </v-chip>
                                <span
                                  v-else-if="index === 100"
                                >
                                  +{{ uploadFiles.length - 100 }} ファイル
                                </span>
                              </template>
                            </v-file-input>
                          </v-col>
                        </v-form>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="blue darken-1"
                      text
                      :loading="loadingSave"
                      :disabled="loadingSave || disableSave"
                      @click="save"
                    >
                      確定
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- ↑↑新規依頼作成ダイアログ -->
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="iraiList"
              no-data-text="データがありません"
              no-results-text="該当するデータがありません"
              multi-sort
              :search="iraiListSearch"
              :custom-filter="iraiListFilter"
              height="100%"
              :mobile-breakpoint="960"
              :sort-by="iraiListSortBy"
              :sort-desc="iraiListSortDesc"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, -1],
                showFirstLastPage: true,
              }"
              :loading="iraiListLoading"
            >
              <template
                v-if="!deleteFilterFlg"
                v-slot:item.action="{ item }"
              >
                <v-badge
                  v-if="noReadIraiId.indexOf(item.id) >= 0"
                  color="error"
                  icon="mdi-exclamation-thick"
                  overlap
                >
                  <v-btn
                    color="primary"
                    small
                    @click="showDetailIrai(item);"
                  >
                    詳細
                  </v-btn>
                </v-badge>
                <v-btn
                  v-else
                  color="primary"
                  small
                  @click="showDetailIrai(item)"
                >
                  詳細
                </v-btn>
                <v-btn
                  v-if="user.type === Constant.UserType.Host && user.auth === Constant.UserAuthType.Admin"
                  color="#BDBDBD"
                  small
                  style="margin-left: 10px"
                  @click="moveThreadItemCheck(item)"
                >
                  移動
                </v-btn>
                <v-btn
                  v-if="user.type === Constant.UserType.Host && user.auth === Constant.UserAuthType.Admin"
                  color="gray"
                  small
                  style="margin-left: 10px"
                  @click.stop="deleteIrai(item)"
                >
                  削除
                </v-btn>
              </template>
              <template
                v-else
                v-slot:item.action="{ item }"
              >
                <v-btn
                  color="primary"
                  small
                  @click="showDetailIrai(item)"
                >
                  詳細
                </v-btn>
                <v-btn
                  v-if="user.type === Constant.UserType.Host && activeTreeItemDeleteFlg === false"
                  color="#BDBDBD"
                  small
                  style="margin-left: 10px"
                  @click="undoDeleteFlgIrai(item)"
                >
                  元に戻す
                </v-btn>
                <v-btn
                  v-if="user.type === Constant.UserType.Host && activeTreeItemDeleteFlg === false"
                  color="gray"
                  small
                  style="margin-left: 10px"
                  @click.stop="deleteIrai(item)"
                >
                  完全削除
                </v-btn>
              </template>
              <template
                v-slot:item.deleteFlg="{ }"
              />
            </v-data-table>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

      <!-- ↓↓誤送信防止 -->
      <v-dialog
        v-model="sendCheckDialog"
        width="500"
        persistent
      >
        <v-card>
          <v-card-title primary-title>
            誤送信防止
          </v-card-title>
          <v-card-text>送信する顧問先名を入力してください</v-card-text>
          <v-container>
            <v-col
              cols="12"
              xs="12"
              sm="12"
              md="12"
              align="center"
            >
              <p>{{ editedItem.company }}</p>
            </v-col>
            <v-col
              cols="12"
              xs="12"
              sm="12"
              md="12"
            >
              <v-form
                ref="sendCheckForm"
                v-model="valid"
                lazy-validation
                @submit.prevent
              >
                <v-text-field
                  v-model="sendCompanyName"
                  label="送信顧問先名を入力(※)"
                  required
                  maxlength="100"
                  :rules="[v => !!v || &quot;送信顧問先名は必須です&quot;]"
                />
              </v-form>
            </v-col>
          </v-container>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              text
              @click="onClickCancel();"
            >
              キャンセル
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="onClickOk();"
            >
              確定
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ↑↑誤送信防止 -->


      <!-- ↓↓依頼一覧 依頼詳細-->
      <v-dialog
        v-model="detailDialog"
        width="1000"
        scrollable
        persistent
        :fullscreen="mobileFlg"
      >
        <v-card style="overflow-y:auto">
          <v-card-actions class="pa-0">
            <v-spacer />
            <v-btn
              icon
              color="#3F51B5"
              :loading="loadingClearNoReadMessage"
              :disabled="loadingClearNoReadMessage"
              @click="clearNoReadMessage(); stateDisableFlg = false; iPhoneMessageMaxHeight = null;"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-actions>
          <v-card-title
            class="subtitle-2 py-0 pb-2"
          >
            {{ iraiListTitle }}
          </v-card-title>
          <v-card-title
            class="headline py-0"
          >
            {{ detailIraiItem.title }}
            <v-icon
              v-if="user.type === Constant.UserType.Host"
              :disabled="(detailIraiItem.state === Constant.RequestStatusDisp.Complete ? true : false) || deleteFilterFlg === true"
              @click="editIraiDialog = true, editedItem.title = detailIraiItem.title; editIraiDialogCase = 'title'"
            >
              mdi-pencil
            </v-icon>
          </v-card-title>
          <v-container>
            <v-row dense>
              <v-col
                cols="12"
                xs="3"
                sm="3"
                md="3"
              >
                <span>
                  <u>依頼日：{{ detailIraiItem.start }}</u>
                </span>
              </v-col>
              <v-col
                cols="12"
                xs="3"
                sm="3"
                md="3"
              >
                <span>
                  <u>納期：{{ detailIraiItem.end }}</u>
                </span>
                <v-icon
                  v-if="user.type === Constant.UserType.Host"
                  dense
                  :disabled="(detailIraiItem.state === Constant.RequestStatusDisp.Complete ? true : false) || deleteFilterFlg === true"
                  @click="editIraiDialog = true, editedItem.end = detailIraiItem.end; editIraiDialogCase = 'end'"
                >
                  mdi-pencil
                </v-icon>
              </v-col>
              <v-col
                cols="12"
                xs="3"
                sm="3"
                md="3"
              >
                <v-checkbox
                  v-if="user.type === Constant.UserType.Host"
                  v-model="detailIraiItem.state"
                  :true-value="Constant.RequestStatusDisp.Complete"
                  :false-value="Constant.RequestStatusDisp.Incomplete"
                  hide-details
                  :ripple="false"
                  :disabled="deleteFilterFlg || stateDisableFlg"
                  style="margin-top:0px; padding-top:0px;"
                  @change="changeIraiState();"
                >
                  <template slot="label">
                    <u style="color:black;">状態：{{ detailIraiItem.state }}</u>
                  </template>
                </v-checkbox>
              </v-col>
              <v-col
                cols="12"
                xs="3"
                sm="3"
                md="3"
              />
            </v-row>
            <v-row>
              <v-col
                cols="12"
                xs="6"
                sm="6"
                md="6"
              >
                <v-card
                  id="messageDisplay"
                  :max-height="iPhoneFlg ? iPhoneMessageMaxHeight : 590"
                  style="overflow-y:auto;"
                  flat
                >
                  <v-timeline
                    :reverse="timelineReverse"
                    :align-top="true"
                  >
                    <v-timeline-item
                      v-for="message in detailIraiItem.messages"
                      :key="message.messageId"
                      hide-dot
                      :right="user.id !== message.messageOwnerId"
                      :left="user.id === message.messageOwnerId"
                    >
                      <v-subheader v-if="message.noReadFlg">
                        新規メッセージ
                      </v-subheader>
                      <v-divider
                        v-if="message.noReadFlg"
                        id="messageTarget"
                        class="mb-6"
                      />
                      <v-card
                        
                        class="elevation-5"
                        :color="user.id === message.messageOwnerId ? 'indigo lighten-5' : 'grey lighten-3'"
                      >
                        <!-- eslint-disable-next-line -->
                        <v-card-text v-if="message.message" style="white-space:pre-wrap; word-wrap:break-word;" v-html="autoLinkMessage(message.message)"/>
                        <v-card-text class="caption pb-0">
                          <span v-if="message.messageDatetime">
                            {{ message.messageDatetime }}
                          </span>
                          <span v-if="message.messageOwner">
                            {{ message.messageOwner }}
                          </span>
                        </v-card-text>
                        <v-card-actions class="pa-0">
                          <v-btn
                            v-if="message.messageFileListId != null"
                            class="ma-1"
                            color="primary"
                            small
                            @click="showFileDownloadDialog(message)"
                          >
                            <v-icon>mdi-paperclip</v-icon>添付ファイル
                          </v-btn>
                          <v-spacer />
                          <v-icon
                            v-if="(user.id === message.messageOwnerId) || (user.auth === Constant.UserAuthType.Admin)"
                            dense
                            :disabled="(detailIraiItem.state === Constant.RequestStatusDisp.Complete ? true : false) || deleteFilterFlg === true"
                            @click="deleteMessage(message);"
                          >
                            mdi-delete
                          </v-icon>
                        </v-card-actions>
                      </v-card>
                    </v-timeline-item>
                  </v-timeline>
                </v-card>
              </v-col>
              <v-col
                cols="12"
                xs="6"
                sm="6"
                md="6"
              >
                <v-card class="elevation-3">
                  <v-card-text 
                    style="max-height:590px; overflow-y:auto"
                  >
                    <v-container>
                      <v-row dense>
                        <v-form
                          ref="sendIraiMessageForm"
                          v-model="valid"
                          lazy-validation
                          @submit.prevent
                        >
                          <v-col
                            cols="12"
                            xs="12"
                            sm="12"
                            md="12"
                          >
                            <v-textarea
                              v-model="sendIraiMessage"
                              label="メッセージ"
                              auto-grow
                              outlined
                              clearable
                              :disabled="(detailIraiItem.state === Constant.RequestStatusDisp.Complete ? true : false) || deleteFilterFlg === true"
                              counter
                              maxlength="500"
                              :rules="[v => (!!v || uploadFilesMessage.length > 0) || &quot;メッセージかファイルのどちらか必須です&quot;]"
                            />
                          </v-col>
                          <v-col
                            v-if="!mobileFlg"
                            cols="12"
                            xs="12"
                            sm="12"
                            md="12"
                          >
                            <div class="jumbotron jumbotron-extend">
                              <div class="container">
                                <div
                                  id="dropzone"
                                  effectAllowed="move"
                                  style="padding-right:20px;"
                                  @dragleave.prevent
                                  @dragover.prevent
                                  @drop.prevent="onDrop"
                                >
                                  ここにアップロードファイルをドラッグ＆ドロップ
                                </div>
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="12">
                            <v-file-input
                              v-model="uploadFilesMessage"
                              multiple
                              counter
                              persistent-hint
                              :hint="'ファイル添付の制限は100ファイル（合計' + maxUploadBytesDisp + '）です。'"
                              :disabled="(detailIraiItem.state === Constant.RequestStatusDisp.Complete ? true : false) || deleteFilterFlg === true"
                              placeholder="左のアイコンを押してファイル選択"
                              :show-size="1024"
                              :counter-size-string="'{0} ファイル (合計 ' + getAllFileSizeDisp(uploadFilesMessage) + ')'"
                              prepend-icon="mdi-paperclip"
                              :rules="[v => (v.length > 0 || !!sendIraiMessage) || &quot;メッセージかファイルのどちらか必須です&quot;,
                                       v => getAllFileSize(v) <= maxUploadBytes || 'アップロード可能なのは合計'+ maxUploadBytesDisp +'までです',
                                       v => v.length <= 100 || &quot;アップロード可能なのは合計100ファイルまでです&quot;]"
                            >
                              <template v-slot:selection="{ index, text }">
                                <v-chip
                                  v-if="index < 100"
                                  small
                                  label
                                  color="primary"
                                >
                                  {{ text.replace(/iB\)/g, "B)") }}
                                </v-chip>
                                <span
                                  v-else-if="index === 100"
                                >
                                  +{{ uploadFilesMessage.length - 100 }} ファイル
                                </span>
                              </template>
                            </v-file-input>
                          </v-col>
                        </v-form>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="primary"
                      :disabled="(detailIraiItem.state === Constant.RequestStatusDisp.Complete ? true : false) || deleteFilterFlg === true || loadingAddIraiMessage === true"
                      :loading="loadingAddIraiMessage"
                      @click="addIraiMessage"
                    >
                      送信
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- ↑↑依頼一覧 依頼詳細 -->
      <!-- ↓↓依頼一覧 依頼詳細 編集 -->
      <v-dialog
        v-model="editIraiDialog"
        width="500"
        persistent
      >
        <v-card>
          <v-card-title
            v-if="editIraiDialogCase === 'title'"
            primary-title
          >
            タイトル編集
            <v-spacer />
            <v-btn
              icon
              large
              color="#3F51B5"
              @click="editIraiClose('title')"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-title
            v-if="editIraiDialogCase === 'end'"
            primary-title
          >
            納期編集
            <v-spacer />
            <v-btn
              icon
              large
              color="#3F51B5"
              @click="editIraiClose('end')"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-col
            v-if="editIraiDialogCase === 'title'"
            cols="12"
            sm="12"
            md="12"
          >
            <v-form
              ref="editIraiTitleForm"
              v-model="valid"
              lazy-validation
              @submit.prevent
            >
              <v-text-field
                v-model="editedItem.title"
                label="タイトル(※)"
                required
                counter
                maxlength="30"
                :rules="[v => !!v || &quot;タイトルは必須です&quot;]"
              />
            </v-form>
          </v-col>
          <v-col
            v-if="editIraiDialogCase === 'end'"
            cols="12"
            sm="12"
            md="12"
          >
            <v-form
              ref="editIraiEndForm"
              v-model="valid"
              lazy-validation
              @submit.prevent
            >
              <v-text-field
                v-model="editedItem.end"
                label="納期(※)"
                required
                type="date"
                :rules="[v => !!v || &quot;納期は必須です&quot;]"
              />
            </v-form>
          </v-col>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              text
              :loading="loadingEditIraiSave"
              :disabled="loadingEditIraiSave"
              @click="editIraiSave(editIraiDialogCase === 'title' ? 'title' : 'end')"
            >
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ↑↑依頼一覧 依頼詳細 編集 -->
      <!-- ↓↓依頼一覧-添付ファイル確認 -->
      <v-dialog
        v-model="fileDownloadDialog"
        width="700"
        persistent
        scrollable
        :fullscreen="mobileFlg"
      >
        <v-card
          class="mx-auto"
          max-width="700"
        >
          <v-card-title>
            <span class="headline">添付ファイル一覧</span>
            <v-spacer />
            <v-btn
              icon
              large
              color="#3F51B5"
              @click="stopGetFilesPolling(); fileDownloadDialog = false; clearImgObjUrls(); virusCheckFlg = false; showImgListFlg = false; selectedMessageFiles = [];"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-subtitle class="pa-0">
            <v-col
              v-if="!virusCheckFlg"
              cols="12"
              xs="12"
              sm="12"
              md="12"
            >
              <v-btn
                v-if="!mobileFlg"
                color="primary"
                style="margin-right:10px"
                small
                :loading="loadingFileDownload"
                :disabled="loadingFileDownload"
                @click="downloadSelectFile('message');"
              >
                一括ダウンロード
              </v-btn>
              <v-btn
                v-if="showImgListFlg"
                color="grey lighten-3"
                small
                @click="showImgList('message');"
              >
                画像一覧表示
              </v-btn>
            </v-col>
          </v-card-subtitle>
          <v-card-text class="pa-0">
            <v-data-table
              v-model="selectedMessageFiles"
              :headers="fileListMessageHeaders"
              :items="fileListMessage"
              :custom-sort="fileListMessageCustomSort"
              sort-by="filename"
              :sort-desc="false"
              :mobile-breakpoint="960"
              no-data-text="データがありません。"
              :show-select="!virusCheckFlg && !mobileFlg"
              item-key="fileId"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, -1],
                showFirstLastPage: true,
              }"
            >
              <template v-slot:item.action="{ item }">
                <v-btn
                  v-if="!mobileFlg && item.virusCheckState === Constant.VirusCheckState.Ok"
                  color="primary"
                  small
                  :loading="loadingFileDownload"
                  :disabled="loadingFileDownload"
                  style="margin-right: 10px"
                  @click="downloadFile(item.fileId, true)"
                >
                  ダウンロード
                </v-btn>
                <v-btn
                  v-if="item.virusCheckState === Constant.VirusCheckState.Yet"
                  color="primary"
                  small
                  style="margin-right: 10px"
                  disabled
                  :loading="virusChecking"
                >
                  ウィルスチェック中
                </v-btn>
                <v-btn
                  v-if="item.virusCheckState === Constant.VirusCheckState.Ng"
                  color="primary"
                  small
                  style="margin-right: 10px"
                  disabled
                >
                  ウィルスチェックNGのため削除済
                </v-btn>
                <v-btn
                  v-if="item.virusCheckState === Constant.VirusCheckState.Uploading"
                  color="primary"
                  small
                  style="margin-right: 10px"
                  disabled
                  :loading="virusChecking"
                >
                  アップロード中
                </v-btn>
                <v-btn
                  v-if="item.virusCheckState === Constant.VirusCheckState.Exception"
                  color="primary"
                  small
                  style="margin-right: 10px"
                  disabled
                >
                  アップロード失敗
                </v-btn>
                <v-btn
                  v-if="FileUtil.isDispImageFiletype(item.fileType) && item.virusCheckState === Constant.VirusCheckState.Ok"
                  color="grey lighten-3"
                  small
                  style="margin-right: 10px"
                  @click="showSoloImgFile(item)"
                >
                  表示
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- ↑↑依頼一覧-添付ファイル確認 -->
    </v-content>

    <!-- ↓↓画像表示ダイアログ -->
    <v-dialog
      v-model="oriImgDialog"
      persistent
      max-width="700"
      :fullscreen="mobileFlg"
    >
      <v-card>
        <v-card-title primary-title>
          画像 (画像クリックで別ウィンドウ表示)
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="oriImgDialog = false, soloImgFile = '', soloImgFileId = ''"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-container>
          <v-row
            align="center"
            justify="center"
          >
            <v-img
              v-if="oriImgDialog"
              :src="soloImgFile"
              min-height="200"
              min-width="200"
              max-height="100%"
              max-width="100%"
              contain
              @click="showSoloImgFileByThum(soloImgFile, soloImgFileId);"
              @error="catchShowImgError()"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey"
                  />
                </v-row>
              </template>
            </v-img>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- ↑↑画像表示ダイアログ -->
    <!-- ↓↓サムネイル表示ダイアログ -->
    <v-dialog
      v-model="thumImgDialog"
      width="600px"
      persistent
      scrollable
      :fullscreen="mobileFlg"
    >
      <v-card>
        <v-card-title primary-title>
          画像一覧 (画像クリックで別ウィンドウ表示)
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="thumImgDialog = false; imgFileLists = []; clearImgObjUrls();"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="height:70%">
          <v-container>
            <v-row>
              <v-col
                v-for="file in imgFileLists"
                :key="file.fileId"
                cols="6"
              >
                <v-card
                  flat
                  class="d-flex"
                >
                  <v-img
                    v-if="FileUtil.isDispImageFiletype(file.fileType)"
                    height="150px"
                    contain
                    :src="file.fileSrc"
                    @click="showSoloImgFileByThum(file.fileSrc, file.fileId);"
                    @error="catchShowImgError()"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey"
                        />
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
                {{ file.filename }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ↑↑サムネイル表示ダイアログ -->
    <!-- ↑↑依頼一覧 -->

    <!-- ↓↓顧問先ツリービュー -->
    <v-navigation-drawer
      ref="drawer"
      v-model="drawer"
      app
      clipped
      left
      mobile-break-point="1264"
      :width="navigation.width"
    >
      <v-list
        dense
        class="pt-0"
        style="margin-bottom:144px"
      >
        <v-tooltip
          v-model="partTool2"
          right
          nudge-bottom="160"
          :open-on-hover="false"
          z-index="1"
        >
          <template v-slot:activator="{ off }">
            <v-row align="center">
              <v-col
                cols="12"
                sm="12"
                md="12"
                class="py-0 pr-0"
                align="center"
              >
                <v-text-field
                  v-model="searchCompany"
                  label="ここに入力して絞込"
                  single-line
                  solo
                  clearable
                  hide-details
                  :disabled="disableSearchCompany"
                  :readonly="disableSearchCompany"
                  maxlength="30"
                  v-on="off"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="6"
                xs="6"
                class="py-0 pl-5"
                align="center"
              >
                <v-checkbox 
                  v-model="noReadFilterFlg"
                  label="未読のみ表示" 
                  style="margin-top:0px;"
                  dense
                  hide-details
                  :ripple="false"
                  @change="showNoReadTree"
                />
              </v-col>
              <v-col
                v-if="user.type === Constant.UserType.Host && user.auth === Constant.UserAuthType.Admin"
                cols="12"
                sm="6"
                md="6"
                xs="6"
                class="py-0 pl-5"
                align="center"
              >
                <v-checkbox 
                  v-model="deleteFilterFlg"
                  label="削除済み表示" 
                  style="margin-top:0px;"
                  dense
                  hide-details
                  :ripple="false"
                  @change="showDeleteFlgItem"
                />
              </v-col>
            </v-row>
          </template>
          <span v-if="partTool21">
            <h3>← ステップ②</h3>
            <br>歯車ボタン押して
            <br>「顧問先ユーザー招待」を選択し、
            <br>顧問先ユーザーを招待します。
          </span>
          <span v-if="partTool22">
            <h3>← ステップ③</h3>
            <br>先ほど「新規顧問先追加」で追加した
            <br>顧問先を選択します。
          </span>
        </v-tooltip>

        <v-tooltip
          v-if="user.type === Constant.UserType.Host && user.auth === Constant.UserAuthType.Admin"
          v-model="partTool1"
          right
          nudge-bottom="50"
          :open-on-hover="false"
        >
          <template v-slot:activator="{ off }">
            <v-btn
              block
              :disabled="noReadFilterFlg || deleteFilterFlg"
              color="primary"
              @click="addNewCompanyDialog = true;"
              v-on="off"
            >
              + 新規顧問先追加
            </v-btn>
          </template>
          <span>
            <h3>← ステップ①</h3>
            <br>「+新規顧問先追加」ボタン押して
            <br>顧問先を新規に追加します。
          </span>
        </v-tooltip>
        <hr>
        <v-treeview
          :items="companies"
          :search="searchCompany"
          :filter="companyListFilter"
          activatable
          item-disabled="hidden"
          hoverable
          :active.sync="activeTreeItem"
          return-object
          @update:active="getIraiList(); tutorialStep4();"
        >
          <template
            slot="label"
            slot-scope="{ item }"
          >
            <a
              style="color:black;"
            >
              <v-icon
                v-if="(noReadFolderId.indexOf(item.id) >= 0 || noReadParentFolderId.indexOf(item.id) >= 0) && !deleteFilterFlg"
                :size="20"
                :color="noReadFolderId.indexOf(item.id) >= 0 ? 'red' : 'black'"
                style="margin-right:-10px;margin-left:-8px;"
              >
                mdi-exclamation-thick
              </v-icon>
              <b v-if="((item.auth && noReadFolderId.indexOf(item.id) >= 0) || (item.auth && noReadParentFolderId.indexOf(item.id) >= 0)) && !deleteFilterFlg">
                {{ item.name }}
              </b>
              <span
                v-else-if="!item.auth"
                style="color:#DDDDDD"
              >
                {{ item.name }}
              </span>
              <span v-else>
                {{ item.name }}
              </span>
            </a>
          </template>
          <template
            slot="append"
            slot-scope="{ item }"
          >
            <v-menu
              v-if="(user.type === Constant.UserType.Host && item.auth ) && ((deleteFilterFlg === false) || (deleteFilterFlg === true && item.deleteFlg === true && isShowIconDeleteFlg(item)))"
              offset-y
              nudge-left="170"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  depressed
                  text
                  icon
                  v-on="on"
                >
                  <v-icon :size="20">
                    mdi-cog-outline
                  </v-icon>
                </v-btn>
              </template>
              <v-list v-if="!deleteFilterFlg">
                <v-list-item
                  v-if="item.lev !== 3"
                  @click="addNewChildTo(item)"
                >
                  <v-list-item-title>追加</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="(user.auth === Constant.UserAuthType.Admin) || (user.auth === Constant.UserAuthType.General && item.lev === 1)"
                  @click="moveTreeItemCheck(item)"
                >
                  <v-list-item-title>移動</v-list-item-title>
                </v-list-item>
                <v-list-item @click="changeTreeName(item)">
                  <v-list-item-title>名前の変更</v-list-item-title>
                </v-list-item>
                <v-list-item 
                  v-if="user.auth === Constant.UserAuthType.Admin"
                  @click="openOwnUserAuthUserDialog(item);"
                >
                  <v-list-item-title>アクセス権設定</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="item.lev === 1 && user.auth === Constant.UserAuthType.Admin"
                  @click="openCloseAddPartUserDialog(true, item.id); createFirstCompany(item);"
                >
                  <v-list-item-title>顧問先ユーザー招待</v-list-item-title>
                </v-list-item>        
                <v-menu
                  offset-x
                >
                  <template v-slot:activator="{ on }">
                    <v-list-item
                      v-on="on"
                      @click="checkTreeUsedSize(item)"
                    >
                      <v-list-item-title>
                        使用容量確認
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                  <v-list>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-subtitle>このフォルダー以下を含めた合計容量</v-list-item-subtitle>
                        <v-list-item-title>{{ treeUsedSize }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-list-item
                  v-if="user.auth === Constant.UserAuthType.Admin"
                  @click="deleteTreeItem(item)"
                >
                  <v-list-item-title>削除</v-list-item-title>
                </v-list-item>
              </v-list>
              <!--↓↓ゴミ箱表示時のメニュー -->
              <v-list v-if="deleteFilterFlg">
                <v-list-item @click="undoDeleteFlgItem(item)">
                  <v-list-item-title>元に戻す</v-list-item-title>
                </v-list-item>
                <v-list-item @click="deleteTreeItem(item)">
                  <v-list-item-title>完全削除</v-list-item-title>
                </v-list-item>
              </v-list>
              <!--↑↑ゴミ箱表示時のメニュー -->
            </v-menu>
          </template>
        </v-treeview>
      </v-list>
    </v-navigation-drawer>
    <!-- ↑↑顧問先ツリービュー -->

    <!-- ↓↓ツリーメニューのダイアログ群 -->
    <v-dialog
      v-model="addNewCompanyDialog"
      width="500"
      persistent
    >
      <v-card>
        <v-card-title primary-title>
          新規顧問先追加
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="$refs.addNewCompanyForm.reset(); addNewCompanyDialog = false;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>新規作成する顧問先名を入力してください。</v-card-text>
        <v-col
          cols="12"
          sm="12"
          md="12"
        >
          <v-form
            ref="addNewCompanyForm"
            v-model="valid"
            lazy-validation
            @submit.prevent
          >
            <v-text-field
              v-model="addNewCompanyItem.name"
              label="顧問先名(※)"
              required
              counter
              maxlength="100"
              :rules="[v => !!v || &quot;顧問先名は必須です&quot;]"
            />
          </v-form>
        </v-col>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            :loading="loadingAddNewCompany"
            :disabled="loadingAddNewCompany"
            @click="addNewCompany();"
          >
            作成
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="addNewChildDialog"
      width="500"
      persistent
    >
      <v-card>
        <v-card-title primary-title>
          フォルダー作成
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="$refs.addNewChildForm.reset(); addNewChildDialog = false;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>新規作成するフォルダー名を入力してください。</v-card-text>
        <v-col
          cols="12"
          sm="12"
          md="12"
        >
          <v-form
            ref="addNewChildForm"
            v-model="valid"
            lazy-validation
            @submit.prevent
          >
            <v-text-field
              v-model="addNewChildItem.name"
              label="フォルダー名(※)"
              required
              counter
              maxlength="100"
              :rules="[v => !!v || &quot;フォルダー名は必須です&quot;]"
            />
          </v-form>
        </v-col>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            :loading="loadingAddNewChild"
            :disabled="loadingAddNewChild"
            @click="addNewChild"
          >
            作成
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="changeTreeNameDialog"
      width="500"
      persistent
    >
      <v-card>
        <v-card-title primary-title>
          名前の変更
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="$refs.changeTreeNameForm.reset(); changeTreeNameDialog = false;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>変更後のフォルダー名を入力してください。</v-card-text>
        <v-col
          cols="12"
          sm="12"
          md="12"
        >
          <v-form
            ref="changeTreeNameForm"
            v-model="valid"
            lazy-validation
            @submit.prevent
          >
            <v-text-field
              v-model="changedTreeName"
              label="フォルダー名(※)"
              required
              counter
              maxlength="100"
              :rules="[v => !!v || &quot;フォルダー名は必須です&quot;]"
            />
          </v-form>
        </v-col>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            :loading="loadingSaveTreeName"
            :disabled="loadingSaveTreeName"
            @click="saveTreeName"
          >
            保存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="moveTreeItemDialog"
      width="500"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title primary-title>
          移動
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="closeMoveTreeItemDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          移動先を指定してください。
          <br>
          <v-col
            cols="12"
            sm="12"
            md="12"
          >
            <v-treeview
              :items="companies"
              :search="defaultCompanyFilter"
              :filter="companyFilter"
              :open="openCompany"
              item-disabled="hidden"
              hoverable
            >
              <template
                slot="label"
                slot-scope="{ item }"
              >
                <span
                  v-if="!item.auth"
                  style="color:#DDDDDD"
                >
                  {{ item.name }}
                </span>
                <span v-else>
                  {{ item.name }}
                </span>
              </template>
              <template
                slot="append"
                slot-scope="{ item }"
              >
                <v-menu
                  v-if="item !== moveBeforeItem && ((item.lev === 1 && moveAbleFlg === 1) ||
                    (item.lev === 2 && moveAbleFlg === 2) ||
                    ((item.lev === 2 || item.lev === 3) && moveAbleFlg === 3))"
                  offset-y
                >
                  <template
                    v-slot:activator="{ on }"
                  >
                    <v-btn
                      color="white"
                      v-on="on"
                    >
                      ここへ移動
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="moveTreeItem(item, 0)">
                      <v-list-item-title>このフォルダーの上へ移動</v-list-item-title>
                    </v-list-item>
                    <v-list-item 
                      v-if="(item.auth && ((item.lev === 2) && moveAbleFlg === 3))"
                      @click="moveTreeItem(item, 99)"
                    >
                      <v-list-item-title>このフォルダーの中へ移動</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="moveTreeItem(item, 1)">
                      <v-list-item-title>このフォルダーの下へ移動</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-treeview>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="checkDeleteDialog"
      width="500"
      persistent
    >
      <v-card>
        <v-card-title primary-title>
          {{ checkDeleteDialogTitle }}
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="deleteCancel"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>{{ checkDeleteDialogMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="deleteCancel"
          >
            キャンセル
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="deleteOk"
          >
            確定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ↑↑ツリーメニューのダイアログ群 -->

    <!-- ↓↓スレッド移動ダイアログ -->
    <v-dialog
      v-model="moveThreadItemDialog"
      width="500"
      persistent
    >
      <v-card>
        <v-card-title primary-title>
          メッセージ移動
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="closeMoveThreadItemDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          移動先を指定してください。
          <br>
        </v-card-text>
        <v-col
          cols="12"
          sm="12"
          md="12"
        >
          <v-treeview
            :items="companies"
            :search="defaultCompanyFilter"
            :filter="companyFilter"
            :open="openCompany"
            item-disabled="hidden"
            hoverable
          >
            <template
              v-if="item.id !== iraiListId"
              slot="append"
              slot-scope="{ item }"
            >
              <v-btn
                color="white"
                @click="moveThreadItem(item)"
              >
                ここへ移動
              </v-btn>
            </template>
          </v-treeview>
        </v-col>
      </v-card>
    </v-dialog>
    <!-- ↑↑スレッド移動ダイアログ -->

    <!-- ↓↓各種設定メニューのダイアログ群 -->
    <!-- ↓↓ユーザー管理 -->
    <user-mainte
      ref="userMainte"
      :user-admin-dialog="userAdminDialogFlg"
      :add-own-user-dialog="addOwnUserDialogFlg"
      :add-part-user-dialog="addPartUserDialogFlg"
      :own-user-auth-user-dialog="ownUserAuthUserDialogFlg"
      :first-companies="firstCompanies"
      :companies="companies"
      :selected-company="selectedCompany"
      :selected-first-company-name="selectedFirstCompanyName"
      :user="user"
      @closeUserAdminDialog="closeUserAdminDialog"
      @openCloseAddOwnUserDialog="openCloseAddOwnUserDialog($event, flg)"
      @openCloseAddPartUserDialog="openCloseAddPartUserDialog($event, flg)"
      @openCloseOwnUserAuthUserDialog="openCloseOwnUserAuthUserDialog($event, flg)"
      @createCompanyList="createCompanyList"
      @setLatestFoldData="setLatestFoldData"
    />
    <!-- ↑↑ユーザー管理 -->

    <!-- ↓↓使用容量確認 -->
    <v-dialog
      v-model="usedLisenceDialog"
      width="600"
      persistent
      :fullscreen="mobileFlg"
    >
      <v-card>
        <v-card-title primary-title>
          利用状況確認
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="usedLisenceDialog = false; usedCapacityDetail = []; licenseCompanies.usedCompanies = [];"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-container>
          <v-row>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-card>
                <v-card-title primary-title>
                  現在の使用容量
                </v-card-title>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-card-text>
                    <h2>契約容量：{{ licenseCapacity.useableCapacity }}GB</h2>
                  </v-card-text>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-card-text class="pr-0">
                    <h2>使用容量：{{ licenseCapacity.usedCapacity }}</h2>
                  </v-card-text>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-btn
                    color="primary"
                    @click="showUsedCapacityDetail();"
                  >
                    顧問先別使用容量
                  </v-btn>
                </v-col>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-card>
                <v-card-title primary-title>
                  現在の顧問先数
                </v-card-title>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-card-text>
                    <h2>契約数：{{ licenseCompanies.useableCompanies }} 顧問先</h2>
                  </v-card-text>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-card-text>
                    <h2>利用数：{{ licenseCompanies.usedCompanies.length }} 顧問先</h2>
                  </v-card-text>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-btn
                    color="primary"
                    @click="companiyListDialog = true;"
                  >
                    利用顧問先一覧
                  </v-btn>
                </v-col>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- ↓↓顧問先別使用容量 -->
    <v-dialog
      v-model="usedCapacityDetailDialog"
      width="600"
      persistent
      :fullscreen="mobileFlg"
    >
      <v-card
        class="mx-auto"
        max-width="600"
      >
        <v-card-title>
          <span class="headline">顧問先別使用容量</span>
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="usedCapacityDetailDialog = false;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-data-table
          :headers="usedCapacityDetailHeaders"
          :items="usedCapacityDetail"
          :custom-sort="usedCapacityDetailCustomSort"
          sort-by="name"
          :mobile-breakpoint="960"
          :sort-desc="false"
          no-data-text="データがありません。"
          :footer-props="{
            'items-per-page-options': [10, 20, 30, -1],
            showFirstLastPage: true,
          }"
        />
      </v-card>
    </v-dialog>
    <!-- ↑↑顧問先別使用容量 -->
    <!-- ↓↓利用顧問先一覧 -->
    <v-dialog
      v-model="companiyListDialog"
      width="600"
      persistent
      :fullscreen="mobileFlg"
    >
      <v-card
        class="mx-auto"
        max-width="600"
      >
        <v-card-title>
          <span class="headline">利用顧問先一覧</span>
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="companiyListDialog = false;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-data-table
          :headers="companiesListHeaders"
          :items="licenseCompanies.usedCompanies"
          item-key="id"
          :mobile-breakpoint="960"
          class="elevation-1"
          :footer-props="{
            'items-per-page-options': [10, 20, 30, -1],
            showFirstLastPage: true,
          }"
        />
      </v-card>
    </v-dialog>
    <!-- ↑↑契約顧問先一覧 -->
    <!-- ↑↑使用容量確認 -->

    <!-- ↓↓アカウント管理 -->
    <v-dialog
      v-model="userAccountDialog"
      max-width="800"
      persistent
      :fullscreen="mobileFlg"
    >
      <v-card>
        <v-card-title primary-title>
          アカウント管理
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="userAccountDialog = false;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card outlined>
          <v-container>
            <v-row
              dense
              align="center"
            >
              <v-col
                cols="12"
                sm="4"
                md="4"
              >
                <v-card-text class="title">
                  ユーザーID：
                </v-card-text>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-card-text class="title">
                  {{ user.cognito_user_name }}
                </v-card-text>
              </v-col>
              <v-col
                cols="12"
                sm="2"
                md="2"
                align="center"
              >
                <v-btn
                  color="primary"
                  @click.stop="changeAccountUserIdDialog = true"
                >
                  変更
                </v-btn>
              </v-col>
            </v-row>
            <v-row
              dense
              align="center"
            >
              <v-col
                cols="12"
                sm="4"
                md="4"
              >
                <v-card-text class="title">
                  メールアドレス：
                </v-card-text>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-card-text class="title">
                  {{ user.email }}
                </v-card-text>
              </v-col>
              <v-col
                cols="12"
                sm="2"
                md="2"
                align="center"
              >
                <v-btn
                  color="primary"
                  @click.stop="changeAccountUserEmailDialog = true"
                >
                  変更
                </v-btn>
              </v-col>
            </v-row>
            <v-row
              dense
              align="center"
            >
              <v-col
                cols="12"
                sm="4"
                md="4"
              >
                <v-card-text class="title">
                  担当者名：
                </v-card-text>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-card-text class="title">
                  {{ user.name }}
                </v-card-text>
              </v-col>
              <v-col
                cols="12"
                sm="2"
                md="2"
                align="center"
              >
                <v-btn
                  color="primary"
                  @click.stop="changeAccountUserNameDialog = true"
                >
                  変更
                </v-btn>
              </v-col>
            </v-row>
            <v-row
              dense
              align="center"
            >
              <v-col
                cols="12"
                sm="4"
                md="4"
              >
                <v-card-text class="title">
                  権限：
                </v-card-text>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-card-text class="title">
                  {{ user.auth === Constant.UserAuthType.Admin ? "管理者" : "一般" }}
                </v-card-text>
              </v-col>
              <v-col
                cols="12"
                sm="2"
                md="2"
                align="center"
              />
            </v-row>
          </v-container>
        </v-card>
        <v-card-actions>
          <v-btn
            color="primary"
            @click.stop="openChangeUserPasswordDialog();"
          >
            パスワード変更
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ↓↓アカウント管理-パスワード変更 -->
    <v-dialog
      v-model="changeUserPasswordDialog"
      width="500"
      persistent
      :fullscreen="mobileFlg"
    >
      <v-card>
        <v-card-title primary-title>
          パスワード変更
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="$refs.changeUserPasswordForm.reset(); changeUserPasswordDialog = false;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>現在のパスワードと新しいパスワードを入力してください。</v-card-text>
        <v-container>
          <v-form
            ref="changeUserPasswordForm"
            v-model="valid"
            @submit.prevent
          >
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <span>現在のパスワード(※)</span>
              <v-text-field
                v-model="beforeChangePassword"
                required
                type="password"
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <span>新しいパスワード(※)</span>
              <create-password-field ref="CreatePasswordField" />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <span>新しいパスワード確認(※)</span>
              <password-field ref="PasswordField" />
            </v-col>
          </v-form>
        </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            :loading="loadingChangeUserPassword"
            :disabled="loadingChangeUserPassword"
            @click="changeUserPassword"
          >
            変更
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ↑↑アカウント管理-パスワード変更 -->

    <!-- ↓↓アカウント管理-ユーザーID変更 -->
    <v-dialog
      v-model="changeAccountUserIdDialog"
      width="500"
      persistent
    >
      <v-card>
        <v-card-title primary-title>
          ユーザーID変更
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="$refs.changeAccountUserIdForm.reset(); changeAccountUserIdDialog = false;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>新しいユーザーIDを入力してください。</v-card-text>
        <v-container>
          <v-col
            cols="12"
            sm="12"
            md="12"
          >
            <v-form
              ref="changeAccountUserIdForm"
              v-model="valid"
              lazy-validation
              @submit.prevent
            >
              <v-text-field
                v-model="newAccountUserId"
                label="新しいユーザーID(※)"
                clearable
                :rules="[v => (v && v.length>= 4) || &quot;ユーザーIDは4文字以上必須です&quot;,
                         v => /^[a-zA-Z0-9-_.]+$/.test(v) || 'ユーザーIDは半角英数字と記号-_.のみ利用できます']"
                counter="48"
                maxlength="48"
                hint="ユーザーIDを入力してください。"
              />
            </v-form>
          </v-col>
        </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            :loading="loadingChangeAccountUserId"
            :disabled="loadingChangeAccountUserId"
            @click="changeAccountUserId();"
          >
            変更
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ↑↑アカウント管理-ユーザーID変更 -->

    <!-- ↓↓アカウント管理-メールアドレス変更 -->
    <v-dialog
      v-model="changeAccountUserEmailDialog"
      width="500"
      persistent
    >
      <v-card>
        <v-card-title primary-title>
          メールアドレス変更
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="$refs.changeAccountUserEmailForm.reset(); changeAccountUserEmailDialog = false;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>新しいメールアドレスを入力してください。</v-card-text>
        <v-container>
          <v-col
            cols="12"
            sm="12"
            md="12"
          >
            <v-form
              ref="changeAccountUserEmailForm"
              v-model="valid"
              lazy-validation
              @submit.prevent
            >
              <v-text-field
                v-model="newAccountUserEmail"
                style="white-space:pre-line; word-wrap:break-word;"
                label="新しいメールアドレス(※)"
                clearable
                :rules="[v => !!v || 'メールアドレスは必須です',
                         v => /[^\s]+@[^\s]+/.test(v) || 'メールアドレスが正しくありません']"
                required
                counter="256"
                maxlength="256"
                hint="「no-reply@wd.weplat.epson.jp」からメールが届きます。受信先で迷惑メールフィルタを設定している場合には、このメールアドレスの受信を許可してください。"
              />
            </v-form>
          </v-col>
        </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            :loading="loadingChangeAccountUserEmail"
            :disabled="loadingChangeAccountUserEmail"
            @click="changeAccountUserEmail();"
          >
            変更
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ↓↓アカウント管理-メールアドレス変更-確認キー -->
    <v-dialog
      v-model="changeAccountUserEmailKeyDialog"
      width="550"
      persistent
    >
      <v-card>
        <v-card-title primary-title>
          メールアドレス 確認キー入力
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="changeAccountUserEmailKeyDialog = false;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          新しいメールアドレスへメールを送信しました。<br>
          メールに記載された確認キーを入力してください。
        </v-card-text>
        <v-container class="pb-8">
          <v-row>
            <v-col
              cols="12"
              align="center"
            >
              <span>確認キー</span>
            </v-col>
            <v-col
              cols="1"
            />
            <v-col
              cols="10"
              align="center"
            >
              <v-form
                ref="changeAccountUserEmailKeyForm"
                v-model="valid"
                lazy-validation
                @submit.prevent
              >
                <v-text-field
                  v-model="changeAccountUserEmailKey"
                  required
                  counter="6"
                  maxlength="6"
                  :rules="[v => !!v || &quot;確認キーは必須です&quot;]"
                  hint="新しいメールアドレスに送信したメール内に記載されている確認キーを入力してください"
                />
              </v-form>
            </v-col>
            <v-col
              cols="1"
            />
            <v-col
              cols="12"
              align="center"
            >
              <v-btn
                color="primary"
                text
                :loading="loadingChangeAccountUserEmailKeyConf"
                :disabled="loadingChangeAccountUserEmailKeyConf"
                @click="changeAccountUserEmailKeyConf();"
              >
                確認キーを送信
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- ↑↑アカウント管理-メールアドレス変更-確認キー -->
    <!-- ↑↑アカウント管理-メールアドレス変更 -->

    <!-- ↓↓アカウント管理-担当者名変更 -->
    <v-dialog
      v-model="changeAccountUserNameDialog"
      width="500"
      persistent
    >
      <v-card>
        <v-card-title primary-title>
          担当者名変更
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="$refs.changeAccountUserNameForm.reset(); changeAccountUserNameDialog = false;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>新しい担当者名を入力してください。</v-card-text>
        <v-container>
          <v-col
            cols="12"
            sm="12"
            md="12"
          >
            <v-form
              ref="changeAccountUserNameForm"
              v-model="valid"
              lazy-validation
              @submit.prevent
            >
              <v-text-field
                v-model="newAccountUserName"
                label="新しい担当者名(※)"
                clearable
                :rules="[v => !!v || &quot;新しい担当者名は必須です&quot;]"
                required
                counter="12"
                maxlength="12"
              />
            </v-form>
          </v-col>
        </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            :loading="loadingChangeAccountUserName"
            :disabled="loadingChangeAccountUserName"
            @click="changeAccountUserName();"
          >
            変更
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ↑↑アカウント管理-担当者名変更 -->

    <!-- ↑↑アカウント管理 -->
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <!-- ↑↑各種設定メニュー関係のダイアログ群 -->

    <v-snackbar
      v-model="tutorialFlg"
      right
      :timeout="0"
    >
      <h2>ナビ表示中</h2>
      <v-btn
        color="primary"
        @click="endTutorial();"
      >
        ナビ表示終了
      </v-btn>
    </v-snackbar>

    <!-- ↓↓ ファイルアップロード プログレスバー -->
    <v-snackbar
      v-model="progressSnackbar"
      :timeout="0"
      vertical
    >
      {{ progressMessage }}
      <br>
      <v-progress-linear
        :color="progressLinearColor"
        height="10"
        :value="progressLinearValue"
        striped
      />
      <br>
      {{ progressLinearValue }}% / 100%
    </v-snackbar>
    <!-- ↑↑ ファイルアップロード プログレスバー -->
    <!-- ↓↓ オーバーレイローディング-->
    <v-overlay
      :value="overlay"
      z-index="10000"
    >
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <!-- ↑↑ オーバーレイローディング-->

    <msg-dlg ref="MsgDlg" />
  </v-app>
</template>

<script>
import Vue from "vue";
import MsgDlg from "./MsgDlg.vue";
import UserMainte from "./TopComponents/UserMainte.vue";
import Amplify ,{Queries, Mutations, GraphqlUtil, Convert, Uuid, Util, FileUtil, Constant, Logger, isMobile} from '../amplify_com.js';
import FileSize from 'filesize';
import CreatePasswordField from "./CreatePasswordField.vue";
import PasswordField from "./PasswordField.vue";
import LoadImage from 'blueimp-load-image';
import AppConfig from '../app_config.json';
import Autolinker from 'autolinker';

export default {
  components: {
    "msg-dlg": MsgDlg,
    "user-mainte": UserMainte,
    "create-password-field": CreatePasswordField,
    "password-field": PasswordField,
  },
  data: () => ({
    header_env: AppConfig.header_env,
    Constant :Constant, // template内で定数クラスを使用するため
    FileUtil :FileUtil, // template内で関数を使用するため
    contentNumber: 1,
    mobileFlg: isMobile.any,
    iPhoneFlg: isMobile.apple.phone,
    iPhoneMessageMaxHeight: null,
    overlay: false,
    valid: true,
    tabs: null,
    mainTabs: null,
    drawer: null,
    right: false,
    left: false,
    moveAbleFlg: 0,
    moveBeforeItem: null,
    moveBeforeIndex: null,
    moveBeforeLev: null,
    iraiListLoading: false,
    stateDisableFlg: false,
    
    //アップロードファイル制限
    maxUploadBytesDisp: "100MB",
    maxUploadBytes: 104857600,

    //ボタン連打制御系
    loadingAddNewCompany: false,
    loadingAddNewChild: false,
    loadingSaveTreeName: false,
    loadingSave: false,
    disableSave: false,
    disableSerchIraiList: false,
    loadingEditIraiSave: false,
    loadingClearNoReadMessage: false,
    loadingAddIraiMessage: false,
    loadingChangeUserPassword: false,
    loadingChangeAccountUserId: false,
    loadingChangeAccountUserEmail: false,
    loadingChangeAccountUserEmailKeyConf: false,
    loadingChangeAccountUserName: false,
    loadingFileDownload: false,
    
    //ダイアログ群
    newIraiDialog: false,
    teikeiMessageDialog: false,
    newTeikeiMessageDialog: false,
    editTeikeiMessageDialog: false,
    detailDialog: false,
    editIraiDialog: false,
    editIraiDialogCase: "",
    moveThreadItemDialog: false,
    sendCheckDialog: false,
    sendCompanyName: "",
    shareFileUploadDialog: false,
    
    //ユーザー管理コンポーネント(UserMainte.vue)と連携用フラグ一覧
    userAdminDialogFlg: false,
    addOwnUserDialogFlg: false,
    addPartUserDialogFlg: false,
    ownUserAuthUserDialogFlg: false,
    
    //アカウント管理画面用データ
    usedLisenceDialog: false,
    usedCapacityDetailDialog: false,
    companiyListDialog: false,
    userAccountDialog: false,
    changeUserPasswordDialog: false,
    changeAccountUserIdDialog: false,
    changeAccountUserEmailDialog: false,
    changeAccountUserEmailKeyDialog: false,
    changeAccountUserEmailKey: "",
    changeAccountUserNameDialog: false,

    //フォルダ一覧用データ
    activeTreeItem: [],
    addNewCompanyDialog: false,
    addNewChildDialog: false,
    changeTreeNameDialog: false,
    moveTreeItemDialog: false,
    fileDownloadDialog: false,
    templateIraiManageDialog: false,
    oriImgDialog: false,
    thumImgDialog: false,
    noReadFilterFlg: false,
    deleteFilterFlg: false,
    disableSearchCompany: false,
    companyFilterFlg: false,
    companyFilterId: "",
    defaultCompanyFilter: "",
    openCompany: [],
    checkDeleteDialog: false,
    checkDeleteDialogTitle:"",
    checkDeleteDialogMessage:"",
    deleteIraiFolderIdList: [],

    //ナビ表示ツールチップ用データ
    tutorialFlg: false,
    partTool1: false,
    partTool2: false,
    partTool21: false,
    partTool22: false,
    partTool3: false,
    
    //依頼一覧検索結果保持、フィルター用データ
    searchCompany: null,
    endDateFrom: "",
    endDateTo: "",
    stateCheckbox: false,
    mynameCheckbox: false,
    resizeContent: "",

    ////利用状況確認////
    //契約容量格納用
    licenseCapacity: {
      useableCapacity: null,
      usedCapacity: null,
    },
    //契約ライセンス数格納用
    licenseCompanies: {
      useableCompanies: null,
      usedCompanies: [],
    },

    //パスワード変更用
    beforeChangePassword: "",
    newChangePassword: "",
    newChangePassword2: "",
    //画像ファイル用
    soloImgFile: '',
    soloImgFileId: '',
    //ユーザー情報変更用
    newAccountUserId: "",
    newAccountUserEmail: "",
    newAccountUserName: "",
    //ユーザー情報
    user: {
      id: null,
      cognito_user_name: '',
      name: "",
      email: "",
      type: null, // 1:ライセンスのある会社に所属するユーザー, 2:ライセンスのない会社に所属するユーザー
      auth: null, // ユーザー権限
      company : {
        id: '', // 所属会社の情報
        disp_name: '',
        intr_company_id: '', // 紹介会社のID
      }
    },
    //(共通)顧問先一覧格納用
    firstCompanies: [],
    firstCompaniesObj: {
      id: null,
      name: ""
    },
    companiesListHeaders: [
      {text: "顧問先名", value: "name"}
    ],
    //アクセス権
    selectedCompany: null,
    selectedFirstCompanyName: "",
    //顧問先別使用容量一覧ヘッダー
    usedCapacityDetailHeaders: [
      { text: "顧問先名", value: "name" },
      { text: "使用容量", value: "used" }
    ],
    //顧問先別使用容量一覧
    usedCapacityDetail: [],
    //ツリーアイテムの使用容量確認用
    treeUsedSize: null,
    //フォルダー一覧（本来はAPIで取得）
    companies: [],
    //顧問先ユーザー用
    companiesPart: [],
    companiesOwn: [],

    //ツリービュー操作用変数/オブジェクト
    addNewCompanyItem: 
    { 
      id: null,
      lev: 1, 
      name: "", 
      size: 0, 
      auth: true, 
      dispNum: -1, 
      hidden: false, 
      deleteFlg: false, 
      children: [] 
    },
    addNewChildItemTo: null,
    addNewChildItem:{ 
      id: null,
      lev: 1, 
      name: "", 
      size: 0, 
      auth: true, 
      dispNum: -1, 
      hidden: false, 
      deleteFlg: false, 
      children: [] 
    },
    defaultAddNewChildItem:{ 
      id: null,
      lev: 1, 
      name: "", 
      size: 0, 
      auth: true, 
      dispNum: -1, 
      hidden: false, 
      deleteFlg: false, 
      children: [] 
    },
    defaultAddNewCompanyItem:{ 
      id: null,
      lev: 1, 
      name: "", 
      size: 0, 
      auth: true, 
      dispNum: -1, 
      hidden: false, 
      deleteFlg: false, 
      children: [] 
    },
    defaultTreeName: "",
    changedTreeName: "",
    changedTreeNameItem: null,

    //各種設定メニュー表示用(デフォルト)
    menuItems: [
      Constant.MenuItem.UserAccount,
      Constant.MenuItem.LogOut,
    ],
    //各種設定メニュー（管理者）
    menuItemsAdmin: [
      Constant.MenuItem.UserAdmin,
      Constant.MenuItem.UserLisecse,
      Constant.MenuItem.UserAccount,
      Constant.MenuItem.LogOut,
    ],
    //各種設定メニュー（自社一般）
    menuItemsOwn: [
      Constant.MenuItem.UserAccount,
      Constant.MenuItem.LogOut,
    ],
    //各種設定メニュー（顧問先）
    menuItemsPart: [
      Constant.MenuItem.UserAccount,
      Constant.MenuItem.LogOut,
    ],

    searchTable: "", //データテーブル検索文字列格納用
    
    //フォルダ一覧選択情報格納用
    iraiListId: null,
    iraiListTitle: "",
    selectedTree1: null,
    selectedTree2: null,
    selectedTree3: null,
    activeTreeItemDeleteFlg: null,
    iraiListSearch:"",

    //未読表示用リスト
    noReadIraiId:[],
    noReadFolderId:[],
    noReadParentFolderId:[],
    noReadRequestDtlId:{},

    //依頼一覧（APIで取得）
    iraiList: [],
    iraiListSortBy: ['end', 'title'],
    iraiListSortDesc: [false, false],
    //メッセージ添付ファイル一覧ヘッダー
    fileListMessageHeaders: [
      { text: "ファイル名", value: "filename" },
      { text: "サイズ", value: "size" },
      { text: "操作", value: "action", sortable: false, width:"209px" }
    ],
    //メッセージ添付ファイル一覧
    fileListMessage: [],
    virusCheckFlg: false,
    // ウィルスチェックの自動更新中を示すために取得するタイミングでローディング用ボタンに切り替え
    virusChecking: false, 
    // ファイル一覧更新インターバル
    getFilesInterval: null,
    startGetFilesPollingArgs : null,
    showImgListFlg: false,
    //選択ファイル一覧(メッセージ添付ファイルでの)
    selectedMessageFiles: [],
    imgFileLists:[], //画像一覧表示用リスト
    blobUrlLists:[], //メモリ解放用blobUrlリスト

    //アップロード(新規メッセージ)
    uploadFiles: [],
    //アップロード(返信用)
    uploadFilesMessage: [],
    addTelkeiIraiList: false,
    editedIndex: -1,
    editedItem: {
      id: null,
      company: "",
      start: new Date().toISOString().substr(0, 10),
      owner: "",
      state: "",
      end: "",
      title: "",
      messages: [
        {
        messageId: null,
        messageOwner: "",
        messageOwnerId: "",
        messageDatetime: null,
        messageFileListId: null,
        message: "",
        }
      ]
    },
    sendIraiMessage: "",
    defaultItem: {
      id: null,
      company: "",
      start: new Date().toISOString().substr(0, 10),
      owner: "",
      state: "",
      end: "",
      title: "",
      messages: [
        {
        messageId: null,
        messageCompany: "",
        messageOwner: "",
        messageOwnerId: "",
        messageDatetime: null,
        messageFileListId: null,
        message: "",
        }
      ]
    },
    detailIraiItem: {
      id: null,
      company: "",
      start: "",
      owner: "",
      state: "",
      end: "",
      title: "",
      messages: [
       {
        messageId: null,
        messageCompany: "",
        messageOwner: "",
        messageOwnerId: "",
        messageDatetime: null,
        messageFileListId: null,
        message: "",
        }
      ]
    },
    messageObj: {
      messageId: null,
      messageCompany: "",
      messageOwner: "",
      messageOwnerId: "",
      messageDatetime: null,
      message: "",
    },
    okCancelResolve: null,
    timelineReverse: false,
    flg: null,
    navigation: {
        width: 330,
        maxWidth: 900,
        minWidth: 330,
        borderSize: 3
    },
    //autolinker class
    autolinker: new Autolinker({
      urls: { schemeMatches: true, wwwMatches: false, tldMatches: false },
      stripPrefix: false,
      stripTrailingSlash: false,
      email: false,
      phone: false,
      sanitizeHtml: true,
    }),
    // プログレスバー
    progressSnackbar: false,
    progressLinearColor: "light-blue",
    progressLinearValue: 0,
    progressMessage: '',
    // 未読エラーメッセージ
    getUnreadsErrorMsg: '',
    // 未読インターバル
    getUnreadInterval: null,
  }),
  computed: {
    //依頼一覧ヘッダー(納期を日付で絞り込むフィルターと状態フィルターを組込)
    headers() {
      return [
        {
          text: "納期",
          value: "end",
          filter: value => {
            if (!this.endDateFrom && !this.endDateTo) return true;
            var datestr = value + " 00:00:00";
            var date = !datestr ? datestr = "" : new Date(datestr.replace(/-/g, "/"));
            var dateFrom = !this.endDateFrom ? dateFrom = "" : new Date(this.endDateFrom.replace(/-/g, "/"));
            var dateTo = !this.endDateTo ? dateTo = "" : new Date(this.endDateTo.replace(/-/g, "/"));
            if (dateFrom === "" && dateTo !== "") {
              return date.getTime() <= dateTo.getTime();
            } else if (dateFrom !== "" && dateTo === "") {
              return date.getTime() >= dateFrom.getTime();
            } else if (dateFrom !== "" && dateTo !== "") {
              return (
                date.getTime() >= dateFrom.getTime() &&
                date.getTime() <= dateTo.getTime()
              );
            }
          }
        },
        { text: "タイトル", value: "title" },
        { text: "作成者",
          value: "owner",
          filter: value => {
            if (!this.mynameCheckbox) return true;
            else if (this.mynameCheckbox) {
              return value === this.user.name;
            }
          }
        },
        { text: "作成日", value: "start" },
        {
          text: "状態",
          value: "state",
          width:"74px",
          filter: value => {
            if (this.stateCheckbox) return true;
            else if (!this.stateCheckbox) {
              return value == Constant.RequestStatusDisp.Incomplete;
            }
          }
        },
        { text: "", value: "action", sortable: false, width: this.deleteFilterFlg ? "261px" : "210px"},
        { 
          text: "",
          value: "deleteFlg",
          sortable: false,
          align: " d-none",
          filter: value => {
            if (!this.deleteFilterFlg) {
              return value === false;
            }
            else if (this.deleteFilterFlg) {
              return value === true;
            }
          }
          }
      ];
    },
    companyListFilter(){
      if(this.noReadFilterFlg && !this.deleteFilterFlg){
        //「未読のみ表示」のみチェックがついているときは未読フォルダでフィルタする
        return (item) => this.noReadFolderId.indexOf(item.id) >= 0;
      }else if(!this.noReadFilterFlg && this.deleteFilterFlg){
        //「削除済み表示」のみチェックがついているときはゴミ箱フォルダを対象に検索ワードでフィルタする
        return (item,search) => item.deleteFlg && item.name.indexOf(search) !== -1;
      }else if(!this.noReadFilterFlg && !this.deleteFilterFlg){
        //チェックがついていない場合はゴミ箱以外のフォルダを対象に検索ワードでフィルタする
        return (item,search) => !item.deleteFlg && item.name.indexOf(search) !== -1;
      }else{
        //上記以外はデフォルト検索
        return undefined;
      }
    },
    companyFilter(){
      return this.companyFilterFlg
        ? (item) => item.id === this.companyFilterId
        : undefined
    },
  },  
  created: async function () {
    let _result = null;
    let _this = this;
    // ログイン情報のチェック
    await Amplify.Auth.currentUserPoolUser().then(user => {
      _result = user;
    }).catch(error => {
      Logger.log(error);
      _result = null;
    });

    if(!_result){
      //  ログイン画面に戻す
      _this.$router.push({ path: "/" }, () => {}, () => {});
      return;
    }

    // ログイン情報からユーザー情報取得
    _result = null;
    await GraphqlUtil.exec(Queries.GetUser, null).then(result => {
      // 自分のユーザー情報を設定
      _this.setUser(result.data.GetUser);
      _result = result;
    }).catch(error => {
      _result = null;
      Logger.log(error);
      _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
    });

    if(!_result){
      return;
    }

    // ユーザーの属する会社情報取得
    _result = null;
    await GraphqlUtil.exec(Queries.GetCompany, null).then(result => {
      // 1:ライセンスのある会社に所属するユーザー, 2:ライセンスのない会社に所属するユーザー
      _this.user.type = result.data.GetCompany.lisence_lmt > 0 ? Constant.UserType.Host: Constant.UserType.Guest ;
      _this.user.company.id = result.data.GetCompany.uuid;
      _this.user.company.disp_name = result.data.GetCompany.disp_name;
      // 紹介会社 ライセンス数がない会社の所属ユーザなら値が取得される
      _this.user.company.intr_company_id = result.data.GetCompany.intr_company_id;
      _this.user.company.intr_company_disp_name = result.data.GetCompany.intr_company_disp_name;
      _this.user.company.intr_company_lisence_lmt = result.data.GetCompany.intr_company_lisence_lmt;
      _this.user.company.intr_company_strage_lmt = result.data.GetCompany.intr_company_strage_lmt;
      _result = result;
    }).catch(error => {
      _result = null;
      Logger.log(error);
      this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
    });

    if(!_result){
      return;
    }

    // 自ユーザーの参照可能なフォルダ一覧取得
    _result = null;
    await GraphqlUtil.exec(Queries.GetFolds, null).then(result => {
      // 渡された値が階層順にソートされている前提
      _this.companies = []; // 初期化
      for (var i = 0; i < result.data.GetFolds.folds.length; i++) {
        var fold = result.data.GetFolds.folds[i];
        // レコードからレベル判定
        var level = 3;
        var name = fold.name_l3;
        var size = fold.disp_size_l3
        var parentCompanyId = fold.fold_id_l2;
        var trashFlg = fold.trash_l3;
        var auth = fold.auth_flg;
        var dispNum = fold.disp_num_l3;
        if(fold.name_l1 && !fold.name_l2 && !fold.name_l3){
          level = 1;
          // ライセンス数がない会社のユーザなら紹介会社を表示し、共有先としてわかりやすくする
          name = !_this.user.company.intr_company_id ? fold.name_l1 : _this.user.company.intr_company_disp_name;
          size = fold.disp_size_l1
          parentCompanyId = null;
          trashFlg = fold.trash_l1;
          dispNum = fold.disp_num_l1
        } else if(fold.name_l1 && fold.name_l2 && !fold.name_l3){
          level = 2;
          name = fold.name_l2;
          size = fold.disp_size_l2
          parentCompanyId = fold.fold_id_l1;
          trashFlg = fold.trash_l2;
          dispNum = fold.disp_num_l2;
        }
        //フォルダにゴミ箱スレッドが含まれるか判定
        if(fold.req_trash_flg === '1'){
          _this.deleteIraiFolderIdList.push(fold.uuid);
        }

        // Web画面用のデータに変換
        var cl_company = {
          id: fold.uuid,
          lev: level,
          name: name,
          size: size,
          auth: auth,
          dispNum: dispNum, 
          hidden: trashFlg === '1' ? true : false, // 画面として消すフラグ ゴミ箱と連動
          deleteFlg: trashFlg === '1' ? true : false, // ゴミ箱フラグ true:ゴミ箱、false:ゴミ箱ではない
          children:[],
        }

        // 会社追加(再帰前提で適切な場所に追加)
        _this.addCompany(cl_company, parentCompanyId);
      }

      // 会社フォルダ構造を確認
      Logger.log(_this.companies);
      _result = result;
    }).catch(error => {
      Logger.log(error);
      _result = null;
      this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
    });

    if(!_result){
      return;
    }

    // 未読取得
    await _this.getUnreads();

    // 未読ポーリング設定
    window.addEventListener('focus', _this.startGetUnreadsPolling);
    window.addEventListener('blur',  _this.stopGetUnreadsPolling);

    // ナビ表示判定
    if(_this.user.type === Constant.UserType.Host && _this.user.auth === Constant.UserAuthType.Admin && !_this.mobileFlg){
      if(_this.companies.length === 0){
        _this.tutorialStep1();
      }
    }
  },
  mounted() {
    this.setBorderWidth();
    this.setEvents();

    //戻るボタン無効化
    history.pushState(null, null, null);
    window.addEventListener("popstate", function () {
      history.pushState(null, null, null);
      return;
    });
  },
  destroyed() {
    // 未読ポーリング設定をハンドラから削除
    window.removeEventListener('focus', this.startGetUnreadsPolling);
    window.removeEventListener('blur',  this.stopGetUnreadsPolling);

    if(this.getUnreadInterval){
      clearInterval(this.getUnreadInterval)
    }

    // 添付ファイル一覧取得ポーリング設定をハンドラから削除
    window.removeEventListener('focus', this.startGetFilesPolling);
    window.removeEventListener('blur',  this.stopGetFilesPolling);

    if(this.GetFilesInterval){
      clearInterval(this.GetFilesInterval)
    }
  },
  methods: {
    // 未読取得ポーリング開始
    startGetUnreadsPolling: function() {
      let _this = this;
      // 別画面からのフォーカス遷移の場合もあるので、すぐに取得
      _this.getUnreads();
      if(!_this.getUnreadInterval){
        // 未読取得開始
        _this.getUnreadInterval = setInterval(() => {
          _this.getUnreads();
        }, 60000); // 未読再取得の間隔を指定
      }
    },
    // 未読取得ポーリング終了
    stopGetUnreadsPolling: function() {
      if(this.getUnreadInterval){
        clearInterval(this.getUnreadInterval)
      }
      this.getUnreadInterval = null;
    },
    // 未読取得 現在ポーリング実行
    // ログイン中にユーザが削除された場合も考慮し、エラーメッセージ表示
    getUnreads: async function() {
      // ユーザーの属する会社情報取得
      let _this = this;
      await GraphqlUtil.exec(Queries.GetUnreads, null).then(result => {
        //未読表示用リスト初期化
        _this.noReadIraiId = [];
        _this.noReadFolderId = [];
        _this.noReadParentFolderId = [];
        _this.noReadRequestDtlId = {};
        for (var i = 0; i < result.data.GetUnreads.length; i++) {
          var unread = result.data.GetUnreads[i];
          // リソースタイプを判定
          switch (unread.resource_type) {
            case Constant.UnreadResourceType.RequestId:
              // 依頼ID
              _this.noReadIraiId.push(unread.resource_id);
              break;
            case Constant.UnreadResourceType.FoldId:
              // フォルダID
              _this.noReadFolderId.push(unread.resource_id);
              break;
            case Constant.UnreadResourceType.PFoldId:
              // 親フォルダID
              _this.noReadParentFolderId.push(unread.resource_id);
              break;
            case Constant.UnreadResourceType.RequestDtlId:
              // 依頼明細ID
              _this.noReadRequestDtlId[unread.resource_id] = unread;
              break;
          }
        }
      }).catch(error => {
        // エラーメッセージが直近と変わった場合、出力
        var errmsg = Amplify.GetJaErrMsg(error);
        if(errmsg !== _this.getUnreadsErrorMsg){
          _this.getUnreadsErrorMsg = errmsg;
          if(_this.$refs.MsgDlg){
            _this.$refs.MsgDlg.showError(_this.getUnreadsErrorMsg);
          }
        }
      });
    },
    // 会社フォルダに追加
    addCompany(company, parentCompanyId, checkTarget) {
      // 親がない
      if(!parentCompanyId){
        // 第一階層
        this.companies.push(company);
        return;
      }
      if(!checkTarget){
        for (var i = 0; i < this.companies.length; i++) {
          // 再帰開始
          this.addCompany(company, parentCompanyId, this.companies[i]);
        }
        return;
      } else {
        // 親IDチェック
        if(parentCompanyId === checkTarget.id){
          if(!checkTarget.children){
            checkTarget.children = [];
          }
          checkTarget.children.push(company);
          return;
        } else { 
          for (var l = 0; l < checkTarget.children.length; l++) {
            this.addCompany(company, parentCompanyId, checkTarget.children[l]);
          }
          return;
        }
      }
    },
    //フォルダ最新化
    setLatestFoldData: async function() {
      let _this = this;
        // 自ユーザーの参照可能なフォルダ一覧取得
      await GraphqlUtil.exec(Queries.GetFolds, null).then(result => {
        // 渡された値が階層順にソートされている前提
        _this.companies = []; // 初期化
        for (var i = 0; i < result.data.GetFolds.folds.length; i++) {
          var fold = result.data.GetFolds.folds[i];
          // レコードからレベル判定
          var level = 3;
          var name = fold.name_l3;
          var size = fold.disp_size_l3
          var parentCompanyId = fold.fold_id_l2;
          var trashFlg = fold.trash_l3;
          var auth = fold.auth_flg;
          var dispNum = fold.disp_num_l3;
          if(fold.name_l1 && !fold.name_l2 && !fold.name_l3){
            level = 1;
            // ライセンス数がない会社のユーザなら紹介会社を表示し、共有先としてわかりやすくする
            name = !_this.user.company.intr_company_id ? fold.name_l1 : _this.user.company.intr_company_disp_name;
            size = fold.disp_size_l1
            parentCompanyId = null;
            trashFlg = fold.trash_l1;
            dispNum = fold.disp_num_l1
          } else if(fold.name_l1 && fold.name_l2 && !fold.name_l3){
            level = 2;
            name = fold.name_l2;
            size = fold.disp_size_l2
            parentCompanyId = fold.fold_id_l1;
            trashFlg = fold.trash_l2;
            dispNum = fold.disp_num_l2;
          }
          //フォルダにゴミ箱スレッドが含まれるか判定
          if(fold.req_trash_flg === '1'){
            _this.deleteIraiFolderIdList.push(fold.uuid);
          }

          // Web画面用のデータに変換
          var cl_company = {
            id: fold.uuid,
            lev: level,
            name: name,
            size: size,
            auth: auth,
            dispNum: dispNum, 
            hidden: trashFlg === '1' ? true : false, // 画面として消すフラグ ゴミ箱と連動
            deleteFlg: trashFlg === '1' ? true : false, // ゴミ箱フラグ true:ゴミ箱、false:ゴミ箱ではない
            children:[],
          }
          // 会社追加(再帰前提で適切な場所に追加)
          _this.addCompany(cl_company, parentCompanyId);
        }
        // 会社フォルダ構造を確認
        Logger.log(_this.companies);
      }).catch(error => {
        Logger.log(error);
      });
    },
    //リサイズ用関数
    setBorderWidth() {
      let i = this.$refs.drawer.$el.querySelector(
        ".v-navigation-drawer__border"
      );
      i.style.width = this.navigation.borderSize + "px";
      i.style.cursor = "ew-resize";
    },
    setEvents() {
      const el = this.$refs.drawer.$el;
      const drawerBorder = el.querySelector(".v-navigation-drawer__border");
      const _this = this;

      function resize(e) {
        document.body.style.cursor = "ew-resize";
        let f = e.clientX;
        if(f < _this.navigation.maxWidth && f > _this.navigation.minWidth){
          el.style.width = f + "px";
        }
      }

      drawerBorder.addEventListener(
        "mousedown",
        function(e) {
          if (e.offsetX < _this.navigation.borderSize) {
            el.style.transition ='initial'; document.addEventListener("mousemove", resize, false);
          }
        },
        false
      );

      document.addEventListener(
        "mouseup",
        function() {
          el.style.transition ='';
          _this.navigation.width = el.style.width;
          document.body.style.cursor = "";
          document.removeEventListener("mousemove", resize, false);
        },
        false
      );
    },
    //↑リサイズ用関数

    //ユーザー管理ダイアログ制御
    closeUserAdminDialog() {
      this.userAdminDialogFlg = false;
    },
    openCloseAddOwnUserDialog(flg) {
      this.addOwnUserDialogFlg = flg;
    },
    openCloseAddPartUserDialog : async function(flg, id = null) {
      //openの場合ライセンス判定
      if(flg){
        //ライセンス判定
        await this.getUserLicenseCompany();
        //ライセンス数判定
        if(this.licenseCompanies.useableCompanies <= this.licenseCompanies.usedCompanies.length){
          if(id !== null){
            //新しい顧問先か判定
            if(this.licenseCompanies.usedCompanies.findIndex((e) => e.id === id) === -1){
              this.$refs.MsgDlg.showError("ライセンス上限のため、これ以上新しい顧問先ユーザーを招待できません");
              return;
            }
          }
          //選択肢を利用顧問先だけに絞る
          this.firstCompanies = [];
          for (var i = 0; i < this.licenseCompanies.usedCompanies.length; i++) {
            this.firstCompanies.push(this.licenseCompanies.usedCompanies[i]);
          }     
        }
      }
      
      this.addPartUserDialogFlg = flg;
      this.tutorialStep3();
    },
    // フォルダ権限設定ダイアログを開く
    // fold_flg:true このフォルダーに設定
    openOwnUserAuthUserDialog(item) {
      // 対象フォルダをセット
      this.selectedCompany = item;
      //顧問先フィルターのための顧問先名をセット
      let index = this.searchItemIndex(item);
      this.selectedFirstCompanyName = this.companies[index[0]].name;

      setTimeout(() => {
        this.$refs.userMainte.getUserAuthUser(true);
      }, 300);
    },
    openCloseOwnUserAuthUserDialog(flg) {
      this.ownUserAuthUserDialogFlg = flg;
    },

    //依頼新規作成
    newIraiCreate() {
      this.newIraiDialog = true;
    },
    close() {
      this.newIraiDialog = false;
      this.uploadFiles = [];
      setTimeout(() => {
        this.editedItem = Vue.util.extend({}, this.defaultItem);
        this.$refs.newIraiForm.reset();
        this.editedIndex = -1;
        this.loadingSave = false;
      }, 300);
    },
    //新規依頼作成（保存）
    save() {
      //バリデーション
      if (!this.$refs.newIraiForm.validate()) {
        return;
      }
      // 日付フォーマットチェック
      if(!Util.isDateStr(this.editedItem.end)){
        this.$refs.MsgDlg.showError('納期に正しい年月日を入力してください。');
        return;
      }

      //ボタン無効化
      this.loadingSave = true;

      let _this = this;
      this.editedItem.company = this.selectedTree1.name;
      if(this.user.type === Constant.UserType.Host && this.uploadFiles.length > 0){
        //親 かつ ファイル添付されていたら誤送信防止
        this.sendCheck().then(function(ret) {
          if (ret) {
            //誤送信防止をクリアしたので新規登録
            _this.saveIraiCore();
            _this.sendCheckDialog = false;
            _this.$refs.sendCheckForm.reset();
          } else {
            //キャンセルボタン処理
            _this.sendCheckDialog = false;
            _this.$refs.sendCheckForm.reset();
            _this.loadingSave = false;
          }
        });
      }else{
        //誤送信防止なし
        _this.saveIraiCore();
      }
    },
    saveIraiCore(){
      let _this = this;
      // 依頼作成
          const createRequestInput = {
            id:Uuid.getUuid(), 
            fold_id: _this.iraiListId, 
            deliv_date: Convert.dateToStr(_this.editedItem.end), 
            title: _this.editedItem.title,
            message: _this.editedItem.messages[0].message,
          };
          GraphqlUtil.exec(Mutations.CreateRequest, {input: createRequestInput}).then(result => {

            // インサートしたデータを記憶
            let _request = result.data.CreateRequest;

            // ファイルアップロード処理
            const uploadArgs = {
              msg_dtl_id:result.data.CreateRequest.first_dtl_id,
            };
            // ファイルアップロードを実行する
            _this.doUpload(uploadArgs, _this.uploadFiles).then(() => {

              // データ追加
              _this.editedItem  = {
                id: _request.uuid,
                folderId: _this.iraiListId,
                start: Convert.dateToDispStr(_request.req_date),
                owner: _request.req_user_name,
                state: _request.status === Constant.RequestStatus.Incomplete ? Constant.RequestStatusDisp.Incomplete : Constant.RequestStatusDisp.Complete,
                end: Convert.dateToDispStr(_request.deliv_date),
                title: _request.title,
                deleteFlg: false,
                messages: [{message: ""}], // エラー回避
              };
              _this.iraiList.push(_this.editedItem);
              _this.close();

              //ナビ表示だった場合完了メソッドを呼ぶ
              if(_this.tutorialFlg === true){
                _this.endTutorial();
              }
            }).catch(error => {
              _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
              _this.loadingSave = false;
              _this.sendCheckDialog = false;
            });
          }).catch(error => {
              _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
              _this.loadingSave = false;
              _this.sendCheckDialog = false;
          });
    },
    //誤送信防止チェック用関数
    sendCheck() {
      this.sendCheckDialog = true;
      let _this = this;
      return new Promise(function(resolve) {
        _this.okCancelResolve = resolve;
      });
    },
    onClickOk() {


      //送信先名を比較
      if (this.editedItem.company === this.sendCompanyName) {
        this.okCancelResolve(true);
      } else {
        this.$refs.MsgDlg.showModalError("送信顧問先名が違います");
      }
    },
    onClickCancel() {
      this.okCancelResolve(false);
    },

    //スレッド削除
    deleteIrai : async function(item) {
      let _this = this;
      this.checkDeleteItem(item).then(async function(ret) {
        if (ret) {
          if(!item.deleteFlg){
            //ゴミ箱移動
            let apiResult = null;

            // 依頼単位でゴミ箱に入れるAPI
            const updateRequestTrashInput = {
              req_id : item.id, //依頼ID
              trash : '1', // ゴミ箱に入れるときは'1', 戻す時は'0'
            };
            await GraphqlUtil.exec(Mutations.UpdateRequestTrash, {input: updateRequestTrashInput}).then(result => {
              apiResult = result;
              Logger.log(result);
            }).catch(error => {
              apiResult = null;
              Logger.log(error);
              _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
              _this.overlay = false;
            });

            if(!apiResult){
              _this.overlay = false;
              return;
            }

            // 未読取得 非同期で実施しても問題なし
            setTimeout(() => {
              _this.getUnreads();
            }, 1);

            //画面処理
            item.deleteFlg = true;
            //削除スレッドフォルダーID一覧に無ければ追加
            if(_this.deleteIraiFolderIdList.indexOf(item.folderId) === -1){
              _this.deleteIraiFolderIdList.push(item.folderId);
            }
            _this.overlay = false;
          }else{
            //スレッド完全削除
            let apiResult = null;
            
            //スレッド完全削除API処理
            await GraphqlUtil.exec(Mutations.DeleteRequest, {req_id: item.id}).then(result => {
              apiResult = result;
              Logger.log(result);
            }).catch(error => {
              apiResult = null;
              Logger.log(error);
              _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
              _this.overlay = false;
            });
            if(!apiResult){
              _this.overlay = false;
              return;
            }

            //画面表示処理
            var index = _this.iraiList.indexOf(item);
            _this.iraiList.splice(index, 1);

            //削除済みスレッドが一件も無ければスレッドフォルダーID一覧から削除
            index = _this.iraiList.findIndex((e) => e.deleteFlg === true);
            if(index === -1){
              var deleteIndex = _this.deleteIraiFolderIdList.indexOf(item.folderId);
              _this.deleteIraiFolderIdList.splice(deleteIndex, 1);
              _this.showDeleteFlgItem();
            }
            _this.overlay = false;
          }
        }
      })
    },

    //依頼詳細表示
    showDetailIrai : async function(item) {
      //ボタン無効化
      this.overlay = true;

      let _this = this;
      // 未読取得
      await _this.getUnreads(false);

      // 明細取得
      await GraphqlUtil.exec(Queries.GetRequestDtls, { 
        req_id: item.id
      }).then(result => {
        //_this.detailDialog = true;
        _this.editedIndex = this.iraiList.indexOf(item);
        // 取得成功した依頼詳細を画面設定
        item.messages = []; // 開くたびにデータが増えないように初期化
        var lastDate = null;
        var lastDateId = null;
        for (var i = 0; i < result.data.GetRequestDtls.length; i++) {
          var requestDtl = result.data.GetRequestDtls[i];
          const message = {
            messageId: requestDtl.uuid,
            messageCompany: requestDtl.send_company_name,
            messageOwner: requestDtl.send_user_name,
            messageOwnerId: requestDtl.send_user_id,
            messageDatetime: Convert.datetimeToStr(requestDtl.created_dt),
            messageFileListId: requestDtl.file_cnt === 0 ? null : requestDtl.uuid, // ファイルがあるなら依頼明細のIDを設定
            messageIraiTitle: item.title , // ファイル明細にタイトルを渡すために設定
            message: requestDtl.msg,
            noReadFlg: false, // 既読で初期化
          }

          // 未読チェック
          if(_this.noReadRequestDtlId[requestDtl.uuid]){
            if(!lastDate){
              lastDate = _this.noReadRequestDtlId[requestDtl.uuid].update_dt;
              lastDateId = requestDtl.uuid;
            } else if(lastDate < _this.noReadRequestDtlId[requestDtl.uuid].update_dt){
              lastDate = _this.noReadRequestDtlId[requestDtl.uuid].update_dt;
              lastDateId = requestDtl.uuid;
            }
          }
          item.messages.push(message);
        }
        // 未読にフラグを設定
        for (var j = 0; j < item.messages.length; j++) {
          if(item.messages[j].messageId === lastDateId){
            item.messages[j].noReadFlg = true;
          }
        }
        _this.detailIraiItem = Vue.util.extend({}, item);
        _this.clearNoRead(item);

        _this.detailDialog = true;
        //最新メッセージor最下部までスクロールする
        _this.$nextTick(function () {
          _this.scrollMessages(false);
          if(this.iPhoneFlg){
            //iPhoneの場合のみ
            _this.setMaxHeight();
          }
        })
        
        _this.overlay = false;
      }).catch(error => {
        // エラー処理
        Logger.log(error);
        _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        _this.overlay = false;
      });
    },
    //メッセージをスクロールさせる
    scrollMessages(addMsg){
      const target = document.getElementById('messageTarget') 
      const element = document.getElementById('messageDisplay')
      if(target && !addMsg){
        //新規メッセージ境界があればそこまでスクロール
        setTimeout( function() {
          var rect = target.getBoundingClientRect();
          if(element.scrollHeight - rect.top <= 300){
            //最下部までスクロール
            element.scrollTop = element.scrollHeight;
          }else{
            var diff = element.scrollHeight - rect.top;
            element.scrollTop = rect.top - diff / 1.8; //誤差修正
          }
        }, 300);
      }else{
        //最下部までスクロール
        element.scrollTop = element.scrollHeight;
      }
    },
    //iPhone用メソッド メッセージ表示領域のmaxHeightを設定する(暫定策)
    setMaxHeight(){
      const element = document.getElementById('messageDisplay')
      if(element){
        setTimeout( function() {
          if(element.scrollHeight < 400){
            //メッセージが少ない場合はmaxHeightを小さくし、スクロール幅を持たせる
            element.style.maxHeight = (element.scrollHeight - 5).toString() + "px";
            this.iPhoneMessageMaxHeight = (element.scrollHeight - 5);
          }else{
            //デフォルトでもスクロール幅がある場合
            element.style.maxHeight = "400px";
            this.iPhoneMessageMaxHeight = 400;
          }
        }, 300);
      }
    },

    //リンクを自動作成する
    autoLinkMessage(msg){
      return this.autolinker.link(this.escapeHTML(msg));
    },
    //エスケープ処理
    escapeHTML(str) {
      if(!str){
        return '';
      }
      str = str.replace(/&/g, '&amp;');
      str = str.replace(/</g, '&lt;');
      str = str.replace(/>/g, '&gt;');
      str = str.replace(/"/g, '&quot;');
      str = str.replace(/'/g, '&#39;');
      return str;
    },

    //未読表示解除
    clearNoRead(item){
      const index = this.noReadIraiId.indexOf(item.id);
      if(index >= 0){
        //スレッド未読マーク消去
        this.noReadIraiId.splice(index, 1);
      }
      //未読が無くなったら
      if(this.noReadIraiId.length === 0){
        if(this.noReadFolderId.indexOf(this.iraiListId) >= 0){
          //直フォルダ未読マーク消去
          this.noReadFolderId.splice(this.noReadFolderId.indexOf(this.iraiListId),1);
          //親フォルダがあれば太字マークを消去
          const parentId = this.searchParentFolderIndex(item.folderId);
          if(parentId.length > 0){
            parentId.forEach(e => {
              this.noReadParentFolderId.splice(this.noReadParentFolderId.indexOf(e),1);
            });
          }
        }
      }
    },
    //未読表示解除（メッセージ）
    clearNoReadMessage : async function(){
      //ボタン無効化
      this.loadingClearNoReadMessage = true;
      
      let _this = this;
      let _result = null;
      // 未読削除
      await GraphqlUtil.exec(Mutations.DeleteUnread, { req_id : _this.detailIraiItem.id}).then(result => {
        _result = result;
      }).catch(error => {
        _result = null;
        _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        _this.loadingClearNoReadMessage = false;
        //エラーでダイアログが閉じれなくなるのを防止
        _this.detailDialog = false;
      });
      
      if(!_result){
        _this.loadingClearNoReadMessage = false;
        //エラーでダイアログが閉じれなくなるのを防止
        _this.detailDialog = false;
        return;
      }

      // 未読取得 非同期で実施しても問題なし
      setTimeout(() => {
        _this.getUnreads();
      }, 1);

      this.detailDialog = false;
      this.editedIndex = -1;
      try {
        //新規メッセージフラグを消去
        const target = this.iraiList.find((v) => v.id === this.detailIraiItem.id);
        target.messages.forEach(mes => {
          mes.noReadFlg = false;
          if(this.noReadRequestDtlId[mes.id]){
            this.noReadRequestDtlId.splice(mes.id,1)
          }
        });
        this.detailIraiItem.messages = [];
      } catch (error) {
        this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
      } finally {
        //バリデーションリセット
        this.$refs.sendIraiMessageForm.reset();
        this.loadingClearNoReadMessage = false;
      }
    },

    //アップロードファイルの合計サイズ計算用
    getAllFileSize(v){
      var size = 0;
      v.forEach(e => {
        size += e.size;
      });
      return size;
    },
    //アップロードファイルの合計サイズ表示用
    getAllFileSizeDisp(files){
      var size = this.getAllFileSize(files);
      return FileSize(size, {round: 1});
    },
    //メッセージ追加
    addIraiMessage : async function(){
      //バリデーション
      if (!this.$refs.sendIraiMessageForm.validate()) {
        return;
      }
      //ボタン無効化
      this.loadingAddIraiMessage = true;

      let _this = this;
      if(this.user.type === Constant.UserType.Host && this.uploadFilesMessage.length > 0){
        this.editedItem.company = this.selectedTree1.name;
        //親 かつ ファイル添付されていたら誤送信防止
        this.sendCheck().then(function(ret) {
          if (ret) {
            //誤送信防止をクリアしたので新規登録
            _this.addIraiMessageCore();
            _this.sendCheckDialog = false;
            _this.editedItem.company = "";
            _this.$refs.sendCheckForm.reset();
          } else {
            //キャンセルボタン処理
            _this.sendCheckDialog = false;
            _this.editedItem.company = "";
            _this.$refs.sendCheckForm.reset();
            _this.loadingAddIraiMessage = false;
          }
        });
      }else{
        //誤送信防止なし
        _this.addIraiMessageCore();
      }
    },
    addIraiMessageCore : async function(){
      var obj = null;
      let _this = this;
      let iraiItem = _this.iraiList[_this.editedIndex];

      // メッセージ詳細作成
      let _result = null;
      const createRequestDtlInput = {
        req_dtl_id : Uuid.getUuid(), 
        file_cnt : _this.uploadFilesMessage.length,
        msg : _this.sendIraiMessage,
        req_id : iraiItem.id,
      };
      await GraphqlUtil.exec(Mutations.CreateRequestDtl, {input: createRequestDtlInput}).then(result => {
        _result = result;
      }).catch(error => {
        _result = null;
        _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        _this.loadingAddIraiMessage = false;
      });
      
      if(!_result){
        _this.loadingAddIraiMessage = false;
        return;
      }

      // メッセージを反映
      _this.messageObj.message = _result.data.CreateRequestDtl.msg;
      _this.messageObj.messageId = _result.data.CreateRequestDtl.uuid;
      _this.messageObj.messageOwner = _result.data.CreateRequestDtl.send_user_name;
      _this.messageObj.messageOwnerId = _result.data.CreateRequestDtl.send_user_id;
      _this.messageObj.messageCompany = _result.data.CreateRequestDtl.send_company_name;
      _this.messageObj.messageDatetime = Convert.datetimeToStr(_result.data.CreateRequestDtl.created_dt);
      _this.messageObj.messageFileListId = _result.data.CreateRequestDtl.file_cnt === 0 ? null :_result.data.CreateRequestDtl.uuid;
      obj = Object.assign({},_this.messageObj);
      _this.iraiList[_this.editedIndex].messages.push(obj);

      //メッセージをスクロール
      _this.$nextTick(function () {
        _this.scrollMessages(true);
        if(this.iPhoneFlg){
          //iPhoneの場合のみ
          _this.setMaxHeight();
        }
      })

      // ファイルアップロード処理
      const uploadArgs = {
        msg_dtl_id : _result.data.CreateRequestDtl.uuid,
      };
      await _this.doUpload(uploadArgs, _this.uploadFilesMessage).catch(error => {
        _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        _this.loadingAddIraiMessage = false;
      });

      //初期化
      _this.$refs.sendIraiMessageForm.reset();
      _this.loadingAddIraiMessage = false;
    },
    editIraiClose(editCase) {
      this.editIraiDialog = false;
      setTimeout(() => {
        this.editedItem = Vue.util.extend({}, this.defaultItem);
        if(editCase === "title"){
          this.$refs.editIraiTitleForm.reset()
        }else if(editCase === "end"){
          this.$refs.editIraiEndForm.reset()
        }
        this.loadingEditIraiSave = false;
      }, 300);
    },
    editIraiSave : async function(editCase) {
      if(editCase === "title"){
        //バリデーション
        if (!this.$refs.editIraiTitleForm.validate()) {
          return;
        }
        this.loadingEditIraiSave = true;
        // 依頼更新API
        await this.updateRequest(this.detailIraiItem.id, this.editedItem.title, null, null).then(result => {
          // 更新成功 画面表示更新
          var title = result.data.UpdateRequest.title;
          this.detailIraiItem.title = title;
          this.iraiList[this.editedIndex].title = title;
        });
      }else if(editCase === "end"){
        //バリデーション
        if (!this.$refs.editIraiEndForm.validate()) {
          return;
        }

        // 日付フォーマットチェック
        if(!Util.isDateStr(this.editedItem.end)){
          this.$refs.MsgDlg.showError('納期に正しい年月日を入力してください。');
          return;
        }

        this.loadingEditIraiSave = true;
        // 依頼更新API
        await this.updateRequest(this.detailIraiItem.id, null, this.editedItem.end, null).then(result => {
          // 更新成功 画面表示更新
          var deliv_date = Convert.dateToDispStr(result.data.UpdateRequest.deliv_date);
          this.detailIraiItem.end = deliv_date;
          this.iraiList[this.editedIndex].end = deliv_date;
        });
      }
      this.editIraiClose();
    },
    // 依頼状態を変更
    changeIraiState : async function(){
      // 依頼更新API
      this.stateDisableFlg = true;
      this.loadingClearNoReadMessage = true;
      var status = this.detailIraiItem.state === Constant.RequestStatusDisp.Incomplete ? Constant.RequestStatus.Incomplete : Constant.RequestStatus.Complete;
      await this.updateRequest(this.detailIraiItem.id, null, null, status).then(result => {
        // 更新成功 画面表示更新
        var statusDisp = result.data.UpdateRequest.status === Constant.RequestStatus.Incomplete ? Constant.RequestStatusDisp.Incomplete : Constant.RequestStatusDisp.Complete;
        this.detailIraiItem.state = statusDisp;
        this.iraiList[this.editedIndex].state = statusDisp;
        setTimeout(() => {
        //連打対策
          this.stateDisableFlg = false;
          this.loadingClearNoReadMessage = false;
        }, 1000);
      }).catch(error => {
        Logger.log(error);
        this.stateDisableFlg = false;
        this.loadingClearNoReadMessage = false;
      });
    },
    // 依頼更新API
    updateRequest : async function(req_id, title, deliv_date, status){
      let _this = this;
      let _result = null;
      const updateRequestInput = {
        uuid : req_id,
        title : title,
        deliv_date : !deliv_date ? null :Convert.dateToStr(deliv_date),
        status : status,
      };
      await GraphqlUtil.exec(Mutations.UpdateRequest, { input: updateRequestInput}).then(result => {
        _result = result;
      }).catch(error => {
        _result = null;
        _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
      });
      return _result;
    },
    //メッセージ個別削除
    deleteMessage(message){
      let _this = this;
      this.checkDeleteItem("message").then(async function(ret) {
        if (ret) {
          // 依頼明細削除
          let _result = null;
          await GraphqlUtil.exec(Mutations.DeleteRequestDtl, { req_dtl_id : message.messageId}).then(result => {
            _result = result;
          }).catch(error => {
            _result = null;
            _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
            _this.overlay = false;
          });
          
          if(!_result){
            _this.overlay = false;  
            return;
          }

          //フロント側削除処理
          var deleteIndex = _this.iraiList[_this.editedIndex].messages.indexOf(message);
          _this.iraiList[_this.editedIndex].messages.splice(deleteIndex, 1)

          _this.overlay = false;
        }
      })
    },

    //各種設定メニューからの振り分け
    menuFunc(menuId) {
      if (menuId === Constant.MenuItem.UserAdmin.menuId) {
        this.showUserAdmin();
      } else if (menuId === Constant.MenuItem.UserLisecse.menuId) {
        // 利用状況確認
        this.showUserLisecse();
      } else if (menuId === Constant.MenuItem.UserAccount.menuId) {
        // ユーザー情報を再取得
        this.appSyncGetUser();
        this.userAccountDialog = true;
      } else if (menuId === Constant.MenuItem.Tutorial.menuId) {
        //this.tutorialStep1();
      } else if (menuId === Constant.MenuItem.LogOut.menuId) {
        //ログアウト処理
        Amplify.Auth.signOut().then(() => {
          this.$refs.MsgDlg.showInfo('ログアウトしています');
          let _this = this;
          setTimeout(() => {
            _this.$router.push({ path: "/" }, () => {}, () => {});
          }, 2000);
        }).catch(() => {
          this.$refs.MsgDlg.showError('ログアウトに失敗しました。再度ログアウトをお願いします。');
        });
      }
    },
    //ナビ表示関数
    tutorialStep1(){
      if(this.tutorialFlg === false){
        this.tutorialFlg = true;
        this.partTool1 = true;
      }else{
        this.endTutorial();
      }
    },
    tutorialStep2(){
      if(this.tutorialFlg === true){
        this.partTool1 = false;
        this.partTool2 = true;
        this.partTool21 = true;
      }
    },
    tutorialStep3(){
      if(this.tutorialFlg === true  && this.partTool21 === true){
        this.partTool21 = false;
        this.partTool22 = true;
      }
    },
    tutorialStep4(){
      if(this.tutorialFlg === true && this.partTool22 === true){
        this.partTool2 = false;
        this.partTool22 = false;
        setTimeout(() => {
          this.partTool3 = true;
      }, 1000);
      }
    },
    endTutorial(){
      if(this.partTool3 === true && this.tutorialFlg === true){
        this.$refs.MsgDlg.showSuccess("ナビ表示を終了します。");
      }
      this.tutorialFlg = false;
      this.partTool1 = false;
      this.partTool2 = false;
      this.partTool3 = false;
    },
    //依頼一覧をLIKE検索
    serchIraiList(){
      // 日付フォーマットチェック
      if(!Util.isDateStr(this.endDateFrom) || !Util.isDateStr(this.endDateTo)){
        this.$refs.MsgDlg.showError('納期に正しい年月日を入力してください。');
        return;
      }

      //アイコン無効化
      this.disableSerchIraiList = true;
      this.iraiListLoading = true;

      let _this = this;
      GraphqlUtil.exec(Queries.GetRequests, { 
        fold_id: _this.iraiListId, 
        status: null, 
        self_flg: null, 
        deliv_date_from: null,
        deliv_date_to: null,
        search_text: this.searchTable,
      }).then(result => {
        // 依頼リストに追加
        _this.iraiList = [];
        for (var i = 0; i < result.data.GetRequests.length; i++) {
          var request = result.data.GetRequests[i];
          const iraiRec = {
            id: request.uuid,
            folderId: _this.iraiListId,
            start: Convert.dateToDispStr(request.req_date),
            owner: request.req_user_name,
            state: request.status === Constant.RequestStatus.Incomplete ? Constant.RequestStatusDisp.Incomplete : Constant.RequestStatusDisp.Complete,
            end: Convert.dateToDispStr(request.deliv_date),
            title: request.title,
            deleteFlg: request.trash === '1' ? true : false, //'1'ならゴミ箱
            messages: [], 
          };
          _this.iraiList.push(iraiRec);
        }
        _this.iraiListLoading = false;
        _this.disableSerchIraiList = false;
      }).catch(error => {
        _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        _this.iraiListLoading = false;
        _this.disableSerchIraiList = false;
      });
    },
    //依頼一覧を取得
    getIraiList() {
      if(this.activeTreeItem.length === 0) return ;
      if(window.innerWidth < 1264) this.drawer = false;
      //権限判定
      if(this.activeTreeItem[0].auth === false){
        this.$refs.MsgDlg.showError("フォルダーへのアクセス権がありません");
        return;
      }
      this.iraiListLoading = true;

      var index = this.searchItemIndex(this.activeTreeItem[0]);
      this.iraiListId = this.activeTreeItem[0].id;
      //選択したフォルダを階層で表示用の取得
      if (this.activeTreeItem[0].lev === 1) {
        this.iraiListTitle = this.activeTreeItem[0].name;
        this.selectedTree1 = this.activeTreeItem[0];
        this.activeTreeItemDeleteFlg = this.activeTreeItem[0].deleteFlg;
      } else if (this.activeTreeItem[0].lev === 2) {
        this.iraiListTitle =
          this.companies[index[0]].name +
          " / " +
          this.companies[index[0]].children[index[1]].name;
        this.selectedTree1 = this.companies[index[0]];
        this.selectedTree2 = this.companies[index[0]].children[index[1]];
        this.activeTreeItemDeleteFlg = this.companies[index[0]].children[index[1]].deleteFlg;
      } else if (this.activeTreeItem[0].lev === 3) {
        this.iraiListTitle =
          this.companies[index[0]].name +
          " / " +
          this.companies[index[0]].children[index[1]].name +
          " / " +
          this.companies[index[0]].children[index[1]].children[index[2]].name;
        this.selectedTree1 = this.companies[index[0]];
        this.selectedTree2 = this.companies[index[0]].children[index[1]];
        this.selectedTree3 = this.companies[index[0]].children[
          index[1]
        ].children[index[2]];
        this.activeTreeItemDeleteFlg = this.companies[index[0]].children[index[1]].children[index[2]].deleteFlg;
      }

      // 対象フォルダの依頼一覧を取得
      let _this = this;
      GraphqlUtil.exec(Queries.GetRequests, { 
        fold_id: _this.iraiListId, 
        status: null, 
        self_flg: null, 
        deliv_date_from: null,
        deliv_date_to: null,
        search_text: null
      }).then(result => {
        // 依頼リストに追加
        _this.iraiList = [];
        for (var i = 0; i < result.data.GetRequests.length; i++) {
          var request = result.data.GetRequests[i];
          const iraiRec = {
            id: request.uuid,
            folderId: _this.iraiListId,
            start: Convert.dateToDispStr(request.req_date),
            owner: request.req_user_name,
            state: request.status === Constant.RequestStatus.Incomplete ? Constant.RequestStatusDisp.Incomplete : Constant.RequestStatusDisp.Complete,
            end: Convert.dateToDispStr(request.deliv_date),
            title: request.title,
            deleteFlg: request.trash === '1' ? true : false, //'1'ならゴミ箱
            messages: [],
          };
          _this.iraiList.push(iraiRec);
        }
        _this.iraiListLoading = false;
      }).catch(error => {
        Logger.log(error);
        _this.iraiListLoading = false;
      });
    },
    //依頼一覧のカスタムフィルタ
    iraiListFilter(value, search, item) {
      if(!this.noReadFilterFlg){
        return true;
      }else if(this.noReadFilterFlg){
        return this.noReadIraiId.indexOf(item.id) >= 0;
      }
    },

    ////↓↓ツリーアイテム操作関数
    //未読のみ表示フィルター
    showNoReadTree(){
      if(this.noReadFilterFlg === true){
        this.searchCompany = "未読";
        this.iraiListSearch = "未読";
        this.disableSearchCompany = true;
      }else{
        this.searchCompany = "";
        this.iraiListSearch = "";
        this.disableSearchCompany = false;
      }
    },
    //削除のみ表示処理
    showDeleteFlgItem(){
      if(this.deleteFilterFlg === true){
        this.showDeleteFlgCompanies();
      }else{
        this.hideDeleteFlgCompanies();
        this.setLatestFoldData();
      }
    },
    //削除済み表示
    showDeleteFlgCompanies(){
      //削除フラグが立っているフォルダを表示しそれ以外は非表示
      this.companies.forEach(e => {
        if(e.deleteFlg){
          e.hidden = false;
        }else{
          e.hidden = true;
        }
        e.children.forEach(e2 => {
          if(e2.deleteFlg){
            e2.hidden = false;
            //子のみに削除フラグがある場合でも親フォルダは表示する
            this.companies[this.searchParentFolderIndex(e2.id)[0]].hidden = false;
          }else{
            e2.hidden = true;
          }
          e2.children.forEach(e3 => {
            if(e3.deleteFlg){
              e3.hidden = false;
              //子のみに削除フラグがある場合でも親フォルダは表示する
              const parentIndex = this.searchParentFolderIndex(e3.id)
              this.companies[parentIndex[0]].hidden = false;
              this.companies[parentIndex[0]].children[parentIndex[1]].hidden = false;
            }else{
              e3.hidden = true;
            }
          });
        });
      });

      //削除フラグのあるスレッドのフォルダーも表示する
      for(var i = 0; i < this.deleteIraiFolderIdList.length; i++){
        var foldIndex = this.searchParentFolderIndex(this.deleteIraiFolderIdList[i])
        if(foldIndex.length === 0){
          var delIndex = this.companies.findIndex((e) => e.id === this.deleteIraiFolderIdList[i]);
          this.companies[delIndex].hidden = false;
        }else if(foldIndex.length === 1){
          delIndex = this.companies[foldIndex].children.findIndex((e) => e.id === this.deleteIraiFolderIdList[i]);
          this.companies[foldIndex].hidden = false;
          this.companies[foldIndex].children[delIndex].hidden = false;
        }else if(foldIndex.length === 2){
          delIndex = this.companies[foldIndex[0]].children[foldIndex[1]].children.findIndex((e) => e.id === this.deleteIraiFolderIdList[i]);
          this.companies[foldIndex[0]].hidden = false;
          this.companies[foldIndex[0]].children[foldIndex[1]].hidden = false;
          this.companies[foldIndex[0]].children[foldIndex[1]].children[delIndex].hidden = false;
        }
      }
    },
    //削除済み表示を戻す
    hideDeleteFlgCompanies(){
      this.companies.forEach(e => {
        if(e.deleteFlg){
          e.hidden = true;
        }else{
          e.hidden = false;
        }
        e.children.forEach(e2 => {
          if(e2.deleteFlg){
            e2.hidden = true;
          }else{
            e2.hidden = false;
          }
          e2.children.forEach(e3 => {
            if(e3.deleteFlg){
              e3.hidden = true;
            }else{
              e3.hidden = false;
            }
          });
        });
      });
    },
    //削除フラグの立っている最も上のフォルダーのみにアイコン表示する制御
    isShowIconDeleteFlg(item){
      let index = this.searchItemIndex(item);
      if(index.length === 1){
        return true;
      }else if(index.length === 2){
        if(this.companies[index[0]].deleteFlg === true){
          return false;
        }else{
          return true;
        }
      }else if(index.length === 3){
        if(this.companies[index[0]].children[index[1]].deleteFlg === true){
          return false;
        }else{
          return true;
        }
      }
    },
    //削除済みフォルダを元に戻す
    undoDeleteFlgItem : async function(item){
      //API処理
      const updateFoldTrashInput = {
        fold_id : item.id,
        trash : '0', // ゴミ箱に入れるときは'1', 戻す時は'0'
      };
      await GraphqlUtil.exec(Mutations.UpdateFoldTrash, {input: updateFoldTrashInput}).then(result => {
        Logger.log(result);
      }).catch(error => {
        Logger.log(error);
      });

      //画面処理
      item.hidden = true;
      item.deleteFlg = false;
      //配下のフォルダも削除フラグを全て戻す
        item.children.forEach(e2 => {
          e2.hidden = true;
          e2.deleteFlg = false;
          e2.children.forEach(e3 => {
            e3.hidden = true;
            e3.deleteFlg = false;
          });
        });
      //子のみに削除フラグがある場合は親フォルダも非表示にする
      const parentIndex = this.searchParentFolderIndex(item.id)
      if(parentIndex.length === 1){
      this.companies[parentIndex[0]].hidden = true;
      }else if(parentIndex.length === 2){
        this.companies[parentIndex[0]].hidden = true;
        this.companies[parentIndex[0]].children[parentIndex[1]].hidden = true;
      }
    },
    //削除済みスレッドをもとに戻す
    undoDeleteFlgIrai : async function(item){
      this.overlay = true;

      let apiResult = null;

      // ゴミ箱から戻すAPI処理
      const updateRequestTrashInput = {
        req_id : item.id, //依頼ID
        trash : '0', // ゴミ箱に入れるときは'1', 戻す時は'0'
      };
      await GraphqlUtil.exec(Mutations.UpdateRequestTrash, {input: updateRequestTrashInput}).then(result => {
        apiResult = result;
        Logger.log(result);
      }).catch(error => {
        apiResult = null;
        Logger.log(error);
        this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        this.overlay = false;
      });

      if(!apiResult){
        this.overlay = false;
        return;
      }

      //画面表示制御
      item.deleteFlg = false;
      this.overlay = false;

      //削除済みスレッドが一件も無ければスレッドフォルダーID一覧から削除
      var index = this.iraiList.findIndex((e) => e.deleteFlg === true);
      if(index === -1){
        var deleteIndex = this.deleteIraiFolderIdList.indexOf(item.folderId);
        this.deleteIraiFolderIdList.splice(deleteIndex, 1);
        this.showDeleteFlgItem();
      }
    },

    // 既に同じ顧問先名が存在するかチェック
    isExistCompanyName(newName){
      let tf = false;
      for(var i = 0; i < this.companies.length; i++){
        if(this.companies[i].name === newName){
          tf = true;
        }
      }
      return tf;
    },
    //新規顧問先追加
    addNewCompany : async function () {
      if(this.isExistCompanyName(this.addNewCompanyItem.name)){
        this.$refs.MsgDlg.showError("既に登録されている顧問先名は登録できません。");
        return;
      }
      if(this.$refs.addNewCompanyForm.validate()) {
        this.loadingAddNewCompany = true;
        // 第一階層 フォルダ作成。
        let _this = this;
        let folds = [];
        let firstfoldid = Uuid.getUuid(); // 重複アップロードを防ぐため、クライアントでID生成
        let updateFoldsResult = null;
        _this.addNewCompanyItem.id = firstfoldid;
        if(_this.companies.length === 0){
          _this.addNewCompanyItem.dispNum = 1;  
        }else{
          _this.addNewCompanyItem.dispNum = _this.companies[_this.companies.length - 1].dispNum + 1;
        }
        const fold = {
          uuid: firstfoldid,
          company_id: null, // 新規フォルダ作成時は会社を紐づけない
          intr_company_id: _this.user.company.id, // 新規作成をしたユーザーの所属会社
          app_id: null,
          fold_id_l1: firstfoldid,
          name_l1: _this.addNewCompanyItem.name,
          disp_size_l1: '0',
          trash_l1: 0, // ゴミ箱にしない
          disp_num_l1: _this.addNewCompanyItem.dispNum, // フォルダー一覧の最後尾に追加
          fold_id_l2: null,
          name_l2: null,
          disp_size_l2: null,
          trash_l2: null,
          disp_num_l2: null,
          fold_id_l3: null,
          name_l3: null,
          disp_size_l3: null,
          trash_l3: null,
          disp_num_l3: null,
        };
        folds.push(fold);
        const updateFoldsInput = {
          folds : folds,
        };
        await GraphqlUtil.exec(Mutations.UpdateFolds, {input: updateFoldsInput}).then(result => {
          updateFoldsResult = result;
        }).catch(error => {
          Logger.log(error);
          updateFoldsResult = null;
          _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
          this.loadingAddNewCompany = false;
        });

        if(!updateFoldsResult){
          this.loadingAddNewCompany = false;
          return;
        }

        //画面に反映
        _this.companies.push(_this.addNewCompanyItem);

        //disableを解除
        this.loadingAddNewCompany = false;

        // ダイアログを閉じる
        _this.closeAddNewCompany();

        //フォルダ最新化
        this.setLatestFoldData();

        //ナビ表示を進める
        this.tutorialStep2();
      }
    },
    closeAddNewCompany() {
      this.addNewCompanyDialog = false;
      setTimeout(() => {
        this.addNewCompanyItem = Vue.util.extend(
          {},
          this.defaultAddNewCompanyItem
        );
        this.$refs.addNewCompanyForm.resetValidation();
      }, 300);
    },
    
    //新規子フォルダ追加
    addNewChild : async function() {
      if (this.$refs.addNewChildForm.validate()) {
        //ボタン無効化
        this.loadingAddNewChild = true;

        let _this = this;
        let updateFoldsResult = null;
        let gotFolds = [];
        var updateFolds = [];
        var paramUpdateFolds = [];
        var fold = null;

        var maxNum = 0;
        var addIndex = 0;
        var i = 0;

        //最新のフォルダ情報取得
        await GraphqlUtil.exec(Queries.GetFolds, null).then(result => {
          gotFolds = result.data.GetFolds.folds;
        }).catch(error => {
          gotFolds = null;
          Logger.log(error);
          _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
          _this.loadingAddNewChild = false;
        });

        if(!gotFolds){
          _this.loadingAddNewChild = false;
          return ;
        }

        //一階層目のchildrenへの追加処理
        if(this.addNewChildItemTo.lev === 1){
          //追加先フォルダidのが1階層目になっている一覧を取得
          updateFolds = gotFolds.filter(e => e.fold_id_l1 === this.addNewChildItemTo.id);

          //追加先２階層目のフォルダ数を取得
          for(i = 0; i < updateFolds.length; i++){
            if(updateFolds[i].disp_num_l2 !== null && maxNum < updateFolds[i].disp_num_l2){
              maxNum = updateFolds[i].disp_num_l2;
              addIndex = i;
            }
          }

          //更新用にcreate_dt, create_user, update_dt, update_user要素を削除する
          paramUpdateFolds = this.toUpdateFoldParams(updateFolds);
          
          //追加する２階層目のフォルダ情報を定義
          let secondfoldid = Uuid.getUuid(); // 重複アップロードを防ぐため、クライアントでID生成        
          _this.addNewChildItem.id = secondfoldid;
          _this.addNewChildItem.dispNum = maxNum + 1;
          fold = {
            uuid: _this.addNewChildItem.id,
            company_id: updateFolds[0].company_id, // 親フォルダのidの参照
            intr_company_id: _this.user.company.id, // 新規作成をしたユーザーの所属会社
            app_id: null,
            fold_id_l1: _this.addNewChildItemTo.id,
            name_l1: updateFolds[0].name_l1,
            disp_size_l1: updateFolds[0].disp_size_l1,
            trash_l1: updateFolds[0].trash_l1, // ゴミ箱にしない
            disp_num_l1: updateFolds[0].disp_num_l1, 
            fold_id_l2: _this.addNewChildItem.id,
            name_l2: _this.addNewChildItem.name,
            disp_size_l2: '0',
            trash_l2: 0,
            disp_num_l2: maxNum + 1, //２階層目の最大値+1(最後尾へ追加)
            fold_id_l3: null,
            name_l3: null,
            disp_size_l3: null,
            trash_l3: null,
            disp_num_l3: null,
          };
          paramUpdateFolds.splice(addIndex + 1, 0, fold); //一番後ろに追加するため+1

          this.selectedFirstCompanyName = updateFolds[0].name_l1;

        //二階層目への追加処理
        }else if(this.addNewChildItemTo.lev === 2){
          //追加先フォルダの１階層目idを取得
          var firstFold = gotFolds.find(e => e.fold_id_l2 === this.addNewChildItemTo.id);

          //追加先フォルダidの一覧を取得
          updateFolds = gotFolds.filter(e => e.fold_id_l1 === firstFold.fold_id_l1);
          //追加先フォルダのindexを取得
          var foldIndex = updateFolds.findIndex(e => e.fold_id_l2 === this.addNewChildItemTo.id);

          //追加先3階層目のフォルダ数とindexを取得
          for(i = 0; i < updateFolds.length; i++){
            if(updateFolds[i].fold_id_l2 === this.addNewChildItemTo.id){
              if(updateFolds[i].disp_num_l3 !== null && maxNum < updateFolds[i].disp_num_l3){
                maxNum = updateFolds[i].disp_num_l3;
                addIndex = i;
              }else {
                addIndex = i;
              }
            }
          }

          //更新用にcreate_dt, create_user, update_dt, update_user要素を削除する
          paramUpdateFolds = this.toUpdateFoldParams(updateFolds);
          
          //追加する3階層目のフォルダ情報を定義
          let thirdfoldid = Uuid.getUuid(); // 重複アップロードを防ぐため、クライアントでID生成        
          _this.addNewChildItem.id = thirdfoldid;
          _this.addNewChildItem.dispNum = maxNum + 1;
          fold = {
            uuid: _this.addNewChildItem.id,
            company_id: updateFolds[foldIndex].company_id, // 親フォルダのidの参照
            intr_company_id: _this.user.company.id, // 新規作成をしたユーザーの所属会社
            app_id: null,
            fold_id_l1: updateFolds[foldIndex].fold_id_l1,
            name_l1: updateFolds[foldIndex].name_l1,
            disp_size_l1: updateFolds[foldIndex].disp_size_l1,
            trash_l1: updateFolds[foldIndex].trash_l1, 
            disp_num_l1: updateFolds[foldIndex].disp_num_l1, 
            fold_id_l2: updateFolds[foldIndex].fold_id_l2,
            name_l2: updateFolds[foldIndex].name_l2,
            disp_size_l2: updateFolds[foldIndex].disp_size_l2,
            trash_l2: updateFolds[foldIndex].trash_l2,
            disp_num_l2: updateFolds[foldIndex].disp_num_l2, 
            fold_id_l3: _this.addNewChildItem.id,
            name_l3: _this.addNewChildItem.name,
            disp_size_l3: '0',
            trash_l3: 0,
            disp_num_l3: maxNum + 1, //3階層目の最大値+1(最後尾へ追加)
          };
          paramUpdateFolds.splice(addIndex + 1, 0, fold); //一番後ろに追加するため+1

          this.selectedFirstCompanyName = updateFolds[foldIndex].name_l1;
        }
        
        //フォルダ更新API呼び出し処理
        const updateFoldsInput = {
          folds : paramUpdateFolds,
        };
        await GraphqlUtil.exec(Mutations.UpdateFolds, {input: updateFoldsInput}).then(result => {
          updateFoldsResult = result;
        }).catch(error => {
          updateFoldsResult = null;
          Logger.log(error);
          _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
          _this.loadingAddNewChild = false;
        });

        if(!updateFoldsResult){
          _this.loadingAddNewChild = false;
          return;
        }
        
        //↓↓画面反映処理
        //階層情報を追加
        this.addNewChildItem.lev = this.addNewChildItemTo.lev + 1;
        //オブジェクトを追加
        this.addNewChildItem.children = [];
        this.addNewChildItemTo.children.push(this.addNewChildItem);
        //ダイアログを閉じる
        this.addNewChildDialog = false;
        this.closeAddNewChild();
        //フォルダ最新化
        this.setLatestFoldData();
      }
    },
    //更新用にcreate_dt, create_user, update_dt, update_user要素を削除する
    toUpdateFoldParams(updateFolds){
      var param = [];

      for(var i = 0; i < updateFolds.length; i++){
        var fold = {
          uuid: updateFolds[i].uuid,
          company_id: updateFolds[i].company_id, 
          intr_company_id: updateFolds[i].intr_company_id,
          app_id: updateFolds[i].app_id,
          fold_id_l1: updateFolds[i].fold_id_l1,
          name_l1: updateFolds[i].name_l1,
          disp_size_l1: updateFolds[i].disp_size_l1,
          trash_l1: updateFolds[i].trash_l1,
          disp_num_l1: updateFolds[i].disp_num_l1, 
          fold_id_l2: updateFolds[i].fold_id_l2,
          name_l2: updateFolds[i].name_l2,
          disp_size_l2: updateFolds[i].disp_size_l2,
          trash_l2: updateFolds[i].trash_l2,
          disp_num_l2: updateFolds[i].disp_num_l2,
          fold_id_l3: updateFolds[i].fold_id_l3,
          name_l3: updateFolds[i].name_l3,
          disp_size_l3: updateFolds[i].disp_size_l3,
          trash_l3: updateFolds[i].trash_l3,
          disp_num_l3: updateFolds[i].disp_num_l3,
        };
        param.push(fold)
      }
      return param;
    },
    //move系更新用に要素を整理する
    toUpdateMoveFoldParams(updateFolds){
      var param = [];

      for(var i = 0; i < updateFolds.length; i++){
        var fold = {
          fold_id: updateFolds[i].uuid,
          disp_num_l1: updateFolds[i].disp_num_l1, 
          disp_num_l2: updateFolds[i].disp_num_l2,
          disp_num_l3: updateFolds[i].disp_num_l3,
        };
        param.push(fold)
      }
      return param;
    },
    addNewChildTo(item) {
      this.addNewChildDialog = true;
      this.addNewChildItemTo = item;
    },
    closeAddNewChild() {
      setTimeout(() => {
        this.addNewChildItem = Vue.util.extend({}, this.defaultAddNewChildItem);
        this.$refs.addNewChildForm.resetValidation();
        this.addNewChildItemTo = null;
        //ボタン無効解除
        this.loadingAddNewChild = false;
      }, 300);
    },
    
    //フォルダ名変更
    changeTreeName(item) {
      this.changeTreeNameDialog = true;
      this.changedTreeNameItem = item;
      this.changedTreeName = item.name;
    },
    //フォルダ名変更保存処理
    saveTreeName : async function() {
      if(!this.$refs.changeTreeNameForm.validate()){
        return ;
      }
      if(this.changedTreeNameItem.lev === 1){
        if(this.isExistCompanyName(this.changedTreeName)){
          this.$refs.MsgDlg.showError("既に登録されている顧問先名は登録できません。");
          return;
        }
      }
      //ボタン無効化
      this.loadingSaveTreeName = true;
      
      let _this = this;
      let updateFoldsResult = null;
      var gotFolds = [];

      //最新のフォルダ情報取得
      await GraphqlUtil.exec(Queries.GetFolds, null).then(result => {
        gotFolds = result.data.GetFolds.folds;
      }).catch(error => {
        gotFolds = null;
        Logger.log(error);
        _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        _this.loadingSaveTreeName = false;
      });

      if(!gotFolds){
        _this.loadingSaveTreeName = false;
        return;
      }

      //名前変更対象のフォルダを取得
      var changeFold = gotFolds.find(e => e.uuid === this.changedTreeNameItem.id);
      //洗い替え対象を絞り込み
      var updateFolds = gotFolds.filter(e => e.fold_id_l1 === changeFold.fold_id_l1);

      //名前更新処理
      if(this.changedTreeNameItem.lev === 1){
        //更新対象が一階層目なら全ての要素の名前を更新
        for(var i = 0; i < updateFolds.length; i++){
          updateFolds[i].name_l1 = this.changedTreeName;
        }
      }else if(this.changedTreeNameItem.lev === 2){
        //更新対象が二階層目ならそのフォルダ以下全ての要素の名前を更新
        for(i = 0; i < updateFolds.length; i++){
          if(updateFolds[i].fold_id_l2 !== null && updateFolds[i].fold_id_l2 === this.changedTreeNameItem.id){
            updateFolds[i].name_l2 = this.changedTreeName;
          }
        }
      }else if(this.changedTreeNameItem.lev === 3){
        //更新対象が三階層目なら対象要素のみ名前を更新
        //更新対象のIndexを取得
        var upIndex = updateFolds.findIndex(e => e.uuid === this.changedTreeNameItem.id);
        updateFolds[upIndex].name_l3 = this.changedTreeName;
      }

      //更新用にcreate_dt, create_user, update_dt, update_user要素を削除する
      var paramUpdateFolds = this.toUpdateFoldParams(updateFolds);

      //API呼び出し処理
      const updateFoldsInput = {
        folds : paramUpdateFolds,
      };
      await GraphqlUtil.exec(Mutations.UpdateFolds, {input: updateFoldsInput}).then(result => {
        updateFoldsResult = result;
      }).catch(error => {
        updateFoldsResult = null;
        Logger.log(error);
        _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        _this.loadingSaveTreeName = false;
      });
      
      if(!updateFoldsResult){
        _this.loadingSaveTreeName = false;
        return;
      }

      //画面反映処理
      this.changedTreeNameItem.name = this.changedTreeName;
      //ダイアログを閉じる
      this.changeTreeNameDialog = false;
      this.closeChangeTreeName();

      //フォルダ最新化
      this.setLatestFoldData();
    },
    closeChangeTreeName() {
      setTimeout(() => {
        this.changedTreeName = this.defaultTreeName;
        this.$refs.changeTreeNameForm.resetValidation();
        this.changedTreeNameItem = null;
        this.loadingSaveTreeName = false;
      }, 300);
    },

    //削除チェックダイアログ
    checkDeleteItem(item) {
      if(!item.deleteFlg){
        this.checkDeleteDialogTitle = "本当に削除しますか？";
        this.checkDeleteDialogMessage = "削除後は「削除済みを表示」から参照できます";
        if(item === "message"){
          this.checkDeleteDialogMessage = "メッセージ削除後は元に戻すことはできません";
        }
      }else{
        this.checkDeleteDialogTitle = "完全に削除しますか？";
        this.checkDeleteDialogMessage = "完全削除後は元に戻すことはできません";
      }
      this.checkDeleteDialog = true;
      let _this = this;
      return new Promise(function (resolve) {
        _this.okCancelResolve = resolve;
      });
    },
    deleteOk(){
      this.okCancelResolve(true);
      this.overlay = true;
      this.checkDeleteDialog = false;
    },
    deleteCancel(){
      this.okCancelResolve(false);
      this.checkDeleteDialog = false;
    },
    
    //フォルダ削除
    deleteTreeItem : async function(item) {
      let _this = this;
      this.checkDeleteItem(item).then(async function(ret) {
        if (ret) {
          if(!item.deleteFlg){
            
            //ゴミ箱フラグDB更新
            let apiResult = null;
            const updateFoldTrashInput = {
              fold_id : item.id, // フォルダID
              trash : '1', // ゴミ箱に入れるときは'1', 戻す時は'0'
            };
            await GraphqlUtil.exec(Mutations.UpdateFoldTrash, {input: updateFoldTrashInput}).then(result => {
              apiResult = result;
              Logger.log(result);
            }).catch(error => {
              apiResult = null;
              Logger.log(error);
              _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
              _this.overlay = false;
            });

            if(!apiResult){
              _this.overlay = false;
              return;
            }

            // 未読取得 非同期で実施しても問題なし
            setTimeout(() => {
              _this.getUnreads();
            }, 1);

            //ゴミ箱フラグを立てる処理(画面処理)
            item.hidden = true;
            item.deleteFlg = true;
            //配下のフォルダも削除フラグを立てる
            item.children.forEach(e2 => {
              e2.hidden = true;
              e2.deleteFlg = true;
              e2.children.forEach(e3 => {
                e3.hidden = true;
                e3.deleteFlg = true;
              });
            });
            _this.overlay = false;
          }else{
            //フォルダ完全削除
            let apiResult = null;
            let err = null;
            //フォルダ完全削除API処理
            await GraphqlUtil.exec(Mutations.DeleteFold, {fold_id: item.id}).then(result => {
              apiResult = result;
              err = null;
              Logger.log(result);
            }).catch(error => {
              apiResult = null;
              err = error;
              Logger.log(error);
              _this.overlay = false;
            });
            
            if(!apiResult){
              _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(err));
              _this.overlay = false;
              return;
            }

            //画面表示処理
            if (item.lev === 1) {
              var index = _this.companies.indexOf(item);
              _this.companies.splice(index, 1);
            } else if (item.lev === 2) {
              //2階層目削除の場合は親indexを検索し削除
              var index2;
              for (var i = 0; i < _this.companies.length; i++) {
                if (_this.companies[i].children.indexOf(item) !== -1) {
                  index2 = _this.companies[i].children.indexOf(item);
                  _this.companies[i].children.splice(index2, 1);
                  break;
                }
              }
            } else if (item.lev === 3) {
              //3階層目削除の場合は2階層目と1階層目のindexを検索し削除
              var index3;
              for (var k = 0; k < _this.companies.length; k++) {
                for (var l = 0; l < _this.companies[k].children.length; l++) {
                  if (_this.companies[k].children[l].children.indexOf(item) !== -1) {
                    index3 = _this.companies[k].children[l].children.indexOf(item);
                    _this.companies[k].children[l].children.splice(index3, 1);
                    break;
                  }
                }
              }
            }
            _this.showDeleteFlgItem();
            _this.overlay = false;
          }
        }
      });
    },
    
    //param：フォルダitem
    //return：フォルダ一覧のindex配列（[1,3,2]：[1階層目index, 2階層目index, 3階層目index]）
    searchItemIndex(item) {
      const index = [];
      if (item.lev === 1) {
        index.push(this.companies.indexOf(item));
      } else if (item.lev === 2) {
        //2階層目削除の場合は親indexを検索し削除
        for (var i = 0; i < this.companies.length; i++) {
          if (this.companies[i].children.indexOf(item) !== -1) {
            index.push(i);
            index.push(this.companies[i].children.indexOf(item));
            break;
          }
        }
      } else if (item.lev === 3) {
        //3階層目削除の場合は2階層目と1階層目のindexを検索し削除
        for (var k = 0; k < this.companies.length; k++) {
          for (var l = 0; l < this.companies[k].children.length; l++) {
            if (this.companies[k].children[l].children.indexOf(item) !== -1) {
              index.push(k);
              index.push(l);
              index.push(this.companies[k].children[l].children.indexOf(item));
              break;
            }
          }
        }
      }
      return index;
    },
    //フォルダidから親フォルダidを検索
    searchParentFolderIndex(childId) {
      const parentId = [];
        //1階層目か判定
        if(this.companies.some((v) => v.id === childId)){
          //1階層目なら親はいないので何もしない
        }else{
          for (var k = 0; k < this.companies.length; k++) {
            //2階層目の子に含まれるか判定。含まれれば親IDを格納
            if (this.companies[k].children.some((v) => v.id === childId)) {
                parentId.push(k);
                break;
              }
            for (var l = 0; l < this.companies[k].children.length; l++) {
              //3階層目の子に含まれるか判定。含まれれば親IDを格納
              if (this.companies[k].children[l].children.some((v) => v.id === childId)) {
                parentId.push(k);
                parentId.push(l);
                break;
              }
            }
          }
        }
        return parentId;
    },
    //フォルダ移動先指定画面表示処理
    moveTreeItemCheck(item) {
      this.moveTreeItemDialog = true;
      this.moveBeforeItem = item;
      this.moveBeforeIndex = this.searchItemIndex(item);
      this.moveBeforeLev = item.lev;
      //移動するフォルダの階層を取得
      //2階層目だったら子がいるかを判定
      if (item.lev === 1) {
        this.moveAbleFlg = 1; //1階層目は同階層のみ移動可能
      } else if (item.lev === 2) {
          this.openCompany.push(this.companies[this.moveBeforeIndex[0]].id);
          this.companyFilterFlg = true;
          this.defaultCompanyFilter = "filter"; //フィルタリングするために適当に指定する
          this.companyFilterId = this.companies[this.moveBeforeIndex[0]].id;
        if (item.children.length === 0) {
          this.moveAbleFlg = 3; //2階層目で子がいない場合は2,3階層へ移動可能
        } else {
          this.moveAbleFlg = 2; //2階層目で子がいる場合は2階層目のみ移動可能
        }
      } else {
        this.openCompany.push(this.companies[this.moveBeforeIndex[0]].id);
        this.companyFilterFlg = true;
        this.defaultCompanyFilter = "filter"; //フィルタリングするために適当に指定する
        this.companyFilterId = this.companies[this.moveBeforeIndex[0]].id;
        this.moveAbleFlg = 3; //3階層目は2,3階層へ移動可能
      }
    },
    //フォルダ移動処理
    moveTreeItem : async function(item, flg) {
      //ボタン無効化
      this.overlay = true;

      //クライアント側データ移動
      await this.moveItem(
        this.companies,
        this.moveBeforeIndex,
        this.moveBeforeLev,
        item,
        flg
      );

      var afterLev = item.lev;
      if(flg === 99){
        afterLev += 1;
      }
      //API保存
      await this.saveMoveTreeItem(item, afterLev);

      //クローズ処理
      this.closeMoveTreeItemDialog();
    },
    closeMoveTreeItemDialog(){
      //クローズ処理
      this.moveTreeItemDialog = false;
      this.overlay = false;
      setTimeout(() => {
        this.companyFilterFlg = false;
        this.defaultCompanyFilter = "";
        this.openCompany = [];
        this.companyFilterId = "";
      }, 500);
    },
    closeMoveThreadItemDialog(){
      //クローズ処理
      this.moveThreadItemDialog = false;
      setTimeout(() => {
        this.companyFilterFlg = false;
        this.defaultCompanyFilter = "";
        this.openCompany = [];
        this.companyFilterId = "";
      }, 500);
    },
    //フォルダ移動のコアロジック
    moveItem(array, beforeIndex, beforeLev, afterItem, flg) {
      var cp = null;
      //移動itemを格納し移動元から削除
      if (beforeLev === 1) {
        cp = array[beforeIndex[0]];
        array.splice(beforeIndex[0], 1);
      } else if (beforeLev === 2) {
        cp = array[beforeIndex[0]].children[beforeIndex[1]];
        array[beforeIndex[0]].children.splice(beforeIndex[1], 1);
      } else if (beforeLev === 3) {
        cp =
          array[beforeIndex[0]].children[beforeIndex[1]].children[
            beforeIndex[2]
          ];
        array[beforeIndex[0]].children[beforeIndex[1]].children.splice(
          beforeIndex[2],
          1
        );
      }
      //移動後のindex取得
      var afterIndex = this.searchItemIndex(afterItem);
      var afterLev = afterItem.lev;

      if(flg !== 99){
      //下へ移動ならindexを+1する
      if (flg === 1) {
        if (afterLev === 1) {
          afterIndex[0] += 1;
        } else if (afterLev === 2) {
          afterIndex[1] += 1;
        } else {
          afterIndex[2] += 1;
        }
      }
      }else{
        afterIndex.push(0);
        afterLev += 1;
      }
      //levに差がある場合は移動item内のlevを全て更新
      if (beforeLev !== afterLev) {
        if (cp.children.length === 0) {
          //子フォルダなし階層移動
          cp.lev = afterLev;
        } else {
          cp.lev = afterLev;
          cp.children.forEach(e => {
            e.lev = afterLev + 1;
          });
        }
      }
      //移動先の配列へ追加する
      if (afterLev === 1) {
        array.splice(afterIndex[0], 0, cp);
      } else if (afterLev === 2) {
        array[afterIndex[0]].children.splice(afterIndex[1], 0, cp);
      } else if (afterLev === 3) {
        array[afterIndex[0]].children[afterIndex[1]].children.splice(
          afterIndex[2],
          0,
          cp
        );
      }
      return array;
    },
    //フォルダ移動API連携
    saveMoveTreeItem : async function(afterItem, afterLev){
      let gotFolds = [];
      let param = [];
      let dispNumApiParam = [];
      let disp = {
        fold_id : null,
        disp_num_l1 : null,
        disp_num_l2 : null,
        disp_num_l3 : null
      };
      const ddisp = {
        fold_id : null,
        disp_num_l1 : null,
        disp_num_l2 : null,
        disp_num_l3 : null
      };
      let dispNumApi = {
        fold_id : null,
        disp_num : null,
      };
      const ddispNumApi = {
        fold_id : null,
        disp_num : null,
      };
      let beforeFoldOld = null;
      let afterFoldOld = null;

      //最新のフォルダ情報取得
      await GraphqlUtil.exec(Queries.GetFolds, null).then(result => {
        gotFolds = result.data.GetFolds.folds;
      }).catch(error => {
        gotFolds = null;
        Logger.log(error);
        this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
      });

      if(!gotFolds){
        return;
      }

      var i, j, index;
      //１階層目だった場合は並べ替えのみ-並び順を取得
      if(this.moveBeforeItem.lev === 1){
          for(index = 0; index < this.companies.length; index++){
            dispNumApi.fold_id = this.companies[index].id
            dispNumApi.disp_num = index + 1;
            dispNumApiParam.push(dispNumApi);
            dispNumApi = Vue.util.extend({}, ddispNumApi);
          }
          //更新後の並び順を設定
          const UpdateUserFoldDispNumInput = {
            fold_disp_nums : dispNumApiParam,
          };          
          //並び順更新API呼び出し
          let apiResult = null;
          await GraphqlUtil.exec(Mutations.UpdateUserFoldDispNum, {input: UpdateUserFoldDispNumInput}).then(result => {
            apiResult = result;
            Logger.log(result);
          }).catch((error) => {
            apiResult = null;
            Logger.log(error);
            this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
          });
          if(!apiResult){
            this.setLatestFoldData();
            return;
          }
          //フォルダ最新化
          this.setLatestFoldData();

      }else if(this.moveBeforeItem.lev === 2 || this.moveBeforeItem.lev === 3){
        //２、３階層目だったらその会社全要素が更新対象
        //移動変更対象のフォルダを取得
        let beforeFold = gotFolds.find(e => e.uuid === this.moveBeforeItem.id);
        let afterFold = gotFolds.find(e => e.uuid === afterItem.id);
        beforeFoldOld = Vue.util.extend({}, beforeFold);
        afterFoldOld = Vue.util.extend({}, afterFold);
        let index = this.companies.findIndex(e => e.id === beforeFold.fold_id_l1)

        if(this.companies[index].lev === 1){
          disp.fold_id = this.companies[index].id
          disp.disp_num_l1 = this.companies[index].dispNum
          param.push(disp);
          disp = Vue.util.extend({}, ddisp);
        }
        for(i = 0; i < this.companies[index].children.length; i++){
          if(this.companies[index].children[i].lev === 2){
            disp.fold_id = this.companies[index].children[i].id
            disp.disp_num_l1 = this.companies[index].dispNum
            disp.disp_num_l2 = i + 1;
            param.push(disp);
            disp = Vue.util.extend({}, ddisp);
            for(j = 0; j < this.companies[index].children[i].children.length; j++){
              disp.fold_id = this.companies[index].children[i].children[j].id
              disp.disp_num_l1 = this.companies[index].dispNum
              disp.disp_num_l2 = i + 1;
              disp.disp_num_l3 = j + 1;
              param.push(disp);
              disp = Vue.util.extend({}, ddisp);
            }
          }
        }
        //更新後の並び順を設定
        const UpdateUserFoldDispNumInput = {
          fold_disp_nums : param,
        };
        let paramUpdateFolds = [];

        let afterDispNum = param.find(e => e.fold_id === this.moveBeforeItem.id);
        //洗い替え対象を絞り込み
        let updateFolds = gotFolds.filter(e => e.fold_id_l1 === beforeFold.fold_id_l1);

        //階層移動していた場合の処理
        if(this.moveBeforeLev !== afterLev){
          if(afterLev === 3){
            //３階層目の情報を付加
            beforeFold.fold_id_l3 = beforeFold.uuid;
            beforeFold.name_l3 = beforeFold.name_l2;
            beforeFold.disp_size_l3 = beforeFold.disp_size_l2;
            beforeFold.trash_l3 = beforeFold.trash_l2;
            beforeFold.disp_num_l3 = afterDispNum.disp_num_l3;

            beforeFold.fold_id_l2 = afterFold.fold_id_l2;
            beforeFold.name_l2 = afterFold.name_l2;
            beforeFold.disp_size_l2 = afterFold.disp_size_l2;
            beforeFold.trash_l2 = afterFold.trash_l2;
            beforeFold.disp_num_l2 = afterDispNum.disp_num_l2;
          }else if(afterLev === 2){
            //３階層目の情報を削除
            beforeFold.fold_id_l2 = beforeFold.uuid;
            beforeFold.name_l2 = beforeFold.name_l3;
            beforeFold.disp_size_l2 = beforeFold.disp_size_l3;
            beforeFold.trash_l2 = beforeFold.trash_l3;
            beforeFold.disp_num_l2 = afterDispNum.disp_num_l2;

            beforeFold.fold_id_l3 = null;
            beforeFold.name_l3 = null;
            beforeFold.disp_size_l3 = null;
            beforeFold.trash_l3 = null;
            beforeFold.disp_num_l3 = null;
          }
        }
        // フォルダ間で移動した場合の処理
        else if((this.moveBeforeLev === 3 && afterLev === 3) && (beforeFoldOld.disp_num_l2 !== afterFoldOld.disp_num_l2)){
          //移動したフォルダの情報を書き換え
          beforeFold.fold_id_l2 = afterFold.fold_id_l2;
          beforeFold.name_l2 = afterFold.name_l2;
          beforeFold.disp_size_l2 = afterFold.disp_size_l2;
          beforeFold.trash_l2 = afterFold.trash_l2;
          beforeFold.disp_num_l2 = afterDispNum.disp_num_l2;
        }
        //洗い替え対象のdispnumを全て更新する
        for(i = 0; i < updateFolds.length; i++){
          let targetFold = UpdateUserFoldDispNumInput.fold_disp_nums.find(e => e.fold_id === updateFolds[i].uuid);
          updateFolds[i].disp_num_l1 = targetFold.disp_num_l1;
          updateFolds[i].disp_num_l2 = targetFold.disp_num_l2;
          updateFolds[i].disp_num_l3 = targetFold.disp_num_l3;
        }
        //更新用にcreate_dt, create_user, update_dt, update_user要素を削除する
        paramUpdateFolds = this.toUpdateFoldParams(updateFolds);

        //フォルダ更新API呼び出し処理
        const updateFoldsInput = {
          calc_flg: true,
          folds : paramUpdateFolds,
        };
        let apiResult = null;
        let _this = this;
        await GraphqlUtil.exec(Mutations.UpdateFolds, {input: updateFoldsInput}).then(result => {
          apiResult = result;
          Logger.log(result);
        }).catch(error => {
          Logger.log(error);
          _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        });
        if(!apiResult){
          this.setLatestFoldData();
          return;
        }
        //フォルダ最新化
        this.setLatestFoldData();
      }
    },
    //スレッド移動先選択画面表示処理
    moveThreadItemCheck(item) {
      this.moveThreadItemDialog = true;
      this.moveBeforeItem = item;
      //同会社内にしか移動できないようにフィルターする
      this.openCompany.push(this.selectedTree1.id);
      this.companyFilterFlg = true;
      this.defaultCompanyFilter = "filter"; //フィルタリングするために適当に指定する
      this.companyFilterId = this.selectedTree1.id;
    },
    //スレッド移動処理
    moveThreadItem : async function(treeItem){
      //ボタン無効化
      this.overlay = true;

      const MoveRequestInput = {
        req_id: this.moveBeforeItem.id,
        prev_fold_id: this.moveBeforeItem.folderId,
        next_fold_id: treeItem.id,
      }
      let _result = null;
      let _this = this;
      await GraphqlUtil.exec(Mutations.MoveRequest, {input:MoveRequestInput}).then(result => {
          _result = result;
          Logger.log(result);
      }).catch(error => {
          _result = null;
          Logger.log(error);
          _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
          _this.overlay = false;
      });

      if(!_result){
        _this.overlay = false;
        return;
      }

      //画面処理
      const bIndex = this.iraiList.indexOf(this.moveBeforeItem);
      this.iraiList.splice(bIndex, 1);

      //移動先へ追加
      this.$refs.MsgDlg.showSuccess(treeItem.name + "へ移動しました。");

      //クローズ処理
      this.moveThreadItemDialog = false;
      this.companyFilterFlg = false;
      this.defaultCompanyFilter = "";
      this.openCompany = [];
      this.companyFilterId = "";
      this.overlay = false;
    },
    //フォルダの使用容量を直接確認
    checkTreeUsedSize(item) {
      this.treeUsedSize = null;
      this.treeUsedSize = item.size;
    },
    ////↑↑ツリーアイテム操作関数
    //ユーザ－管理 開く
    showUserAdmin : async function(){
      if(this.companies.length === 0){
        this.$refs.MsgDlg.showError("「+新規顧問先追加」ボタンを押して、顧問先を新規に追加してください。");
        return;
      }
      this.$refs.userMainte.getUsersByAdmin();
      this.userAdminDialogFlg = true;
    },
    //利用状況確認
    showUserLisecse : async function(){
      //ローディング表示
      this.overlay = true;

      try {
        //顧問先数ライセンス情報取得
        await this.getUserLicenseCompany();

        //初期化
        this.usedCapacityDetail = [];
        // 使用容量取得
        await GraphqlUtil.exec(Queries.GetUsedStrage, null).then(result => {
          // 使用容量を画面反映
          for (var i = 0; i < result.data.GetUsedStrage.length; i++) {
            var com = result.data.GetUsedStrage[i];
            this.licenseCapacity.usedCapacity += com.used_strage;

            var usedCapacity = {
              name: com.company_name,
              used: FileSize(com.used_strage),
              used_numeric: com.used_strage, // ソート用に数値も隠し項目にセット
            }
            // 会社追加
            this.usedCapacityDetail.push(usedCapacity);
          }
          this.licenseCapacity.usedCapacity = FileSize(this.licenseCapacity.usedCapacity);
          Logger.log(result);
        }).catch(error => {
          this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
          Logger.log(error);
        });
      } finally {
        this.overlay = false;
      }
      this.usedLisenceDialog = true;
    },
    getUserLicenseCompany : async function(){
      let _this = this;
      
      this.licenseCompanies.useableCompanies = 0;
      this.licenseCompanies.usedCompanies = [];
      this.licenseCapacity.usedCapacity = 0;
      // ユーザーの属する会社情報取得
      let _result = null;
      await GraphqlUtil.exec(Queries.GetCompany, null).then(result => {
        _result = result;
        // 契約数の取得
        _this.licenseCompanies.useableCompanies = result.data.GetCompany.intr_company_lisence_lmt
        _this.licenseCapacity.useableCapacity = result.data.GetCompany.intr_company_strage_lmt;
      }).catch(error => {
        _result = null;
        Logger.log(error);
        this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
      });

      if(!_result){
        return;
      }

      //最新データ取得
      await GraphqlUtil.exec(Queries.GetFolds, null).then(result => {
        for (var i = 0; i < result.data.GetFolds.folds.length; i++) {
          var fold = result.data.GetFolds.folds[i];
          // レコードからレベル判定
          var id = fold.fold_id_l1;
          var name = fold.name_l1;
          //一階層目だけ格納
          if(fold.name_l1 && !fold.name_l2 && !fold.name_l3){
            id = fold.fold_id_l1;
            name = fold.name_l1;

            var fiCampany = {
              id: id,
              name: name,
            }
            if(fold.company_id !== null){
              this.licenseCompanies.usedCompanies.push(fiCampany);
            }
          }
        }
      }).catch(error => {
        this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        Logger.log(error);
      });
    },
    //顧問先別使用容量確認
    showUsedCapacityDetail : async function(){
      //ダイアログ表示
      this.usedCapacityDetailDialog = true;
    },
    // 顧問先別使用容量テーブル カスタムソート
    usedCapacityDetailCustomSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index.length > 0 && index[0] === "used") {
          // 使用容量の表示は文字列なので、隠し項目の数値でソート
          if (!isDesc[0]) {
            return a.used_numeric - b.used_numeric;
          } else {
            return b.used_numeric - a.used_numeric;
          }
        } else if (index.length > 0 && index[0] === "name") {
          // 顧問先名で比較
          var sort = !isDesc[0] ? 1 : -1;
          return Util.strCmp(a.name, b.name) * sort
        }
      });
      return items;
    },
    //ユーザー情報変更
    //ユーザーID変更処理
    changeAccountUserId: async function() {
      //バリデーション
      if (!this.$refs.changeAccountUserIdForm.validate()) {
        return;
      }
      if(this.newAccountUserId === this.user.cognito_user_name){
        this.$refs.MsgDlg.showError("現在のユーザーIDから変更されていません");
        return;
      }
      //ボタン無効化
      this.loadingChangeAccountUserId = true;
      // cognito username変更 この時点でログインIDが変更される
      let _err = null;
      const user = await Amplify.Auth.currentAuthenticatedUser();
      await Amplify.Auth.updateUserAttributes(user, { preferred_username : this.newAccountUserId }).then(() => {
        _err = null;
      }).catch(err => {
        _err = err;
        this.loadingChangeAccountUserId = false;
      });

      if(_err){
        this.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(_err));
        this.loadingChangeAccountUserId = false;
        return;
      }

      // データベース上のcognito優先ユーザー名更新API
      let _result = null;
      await GraphqlUtil.exec(Mutations.UpdatePreferredUserName, { preferred_user_name : this.newAccountUserId }).then(result => {
        _result = result;
      }).catch(error => {
        _result = null;
        this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        this.loadingChangeAccountUserId = false;
      });

      if(!_result){
        this.loadingChangeAccountUserId = false;
        return;
      }

      // 自分のユーザー情報を設定
      this.setUser(_result.data.UpdatePreferredUserName);

      this.changeAccountUserIdDialog = false;
      this.accountUserId = this.newAccountUserId;
      this.$refs.changeAccountUserIdForm.reset();
      this.newAccountUserId = "";
      this.$refs.MsgDlg.showModalSuccess("ユーザーIDを変更しました。Eiボードのユーザー環境設定にて通知設定をしている場合にはユーザーIDの変更をお願いします。");
      this.loadingChangeAccountUserId = false;
    },
    //ユーザーメールアドレス変更処理
    changeAccountUserEmail: async function() {
      //バリデーション
      if (!this.$refs.changeAccountUserEmailForm.validate()) {
        // メールアドレス入力チェック
        if(!this.newAccountUserEmail){
          this.$refs.MsgDlg.showError("新しいメールアドレスを入力してください。");
        }
        return;
      }
      // 変更前と同じアドレスかチェック
      if(this.newAccountUserEmail === this.user.email){
        this.$refs.MsgDlg.showError("現在のメールアドレスから変更されていません。");
        return;
      }
      //ボタン無効化
      this.loadingChangeAccountUserEmail = true;

      // 最新のユーザ情報を取得
      let cognito_email;
      let result = null;
      await Amplify.Auth.currentUserInfo().then(userInfo => {
        result = userInfo;
        cognito_email = userInfo.attributes.email;
      }).catch(error => {
        Logger.log(error);
        this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        this.loadingChangeAccountUserEmail = false;
        result = null;
      });
      if(!result){
        this.loadingChangeAccountUserEmail = false;
        return;
      }

      const user = await Amplify.Auth.currentAuthenticatedUser()
      // cognito上のメールアドレスと入力したアドレスが同じかチェック
      if(this.newAccountUserEmail === cognito_email){
        // 同じEmailアドレスなので再送
        await Amplify.Auth.verifyUserAttribute(user, 'email')
        .catch(error => {
          Logger.log(error);
          this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
          result = null;
        });
      } else {
        // Emailアドレス変更 この時点でメール送信が発生
        await Amplify.Auth.updateUserAttributes(user, { email: this.newAccountUserEmail })
        .catch(error => {
          Logger.log(error);
          this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
          result = null;
        });
      }
      if(!result){
        this.loadingChangeAccountUserEmail = false;
        return;
      }

      // 確認キー入力 ダイアログ表示
      this.changeAccountUserEmailKey = '';
      this.changeAccountUserEmailKeyDialog = true;
      this.loadingChangeAccountUserEmail = false;

      try {
        // 次画面のバリデーション初期化
        this.$refs.changeAccountUserEmailKeyForm.reset();
      } catch (error){
        Logger.log(error);
      }
    },

    //ユーザーメールアドレス変更 確認キー送信処理
    changeAccountUserEmailKeyConf: async function() {
      //バリデーション
      if (!this.$refs.changeAccountUserEmailKeyForm.validate()) {
        return;
      }
      //ボタン無効化
      this.loadingChangeAccountUserEmailKeyConf = true;

      let _result = null;
      let _err = null;

      // 確認コード送信
      await Amplify.Auth.verifyCurrentUserAttributeSubmit('email', this.changeAccountUserEmailKey).then(result => {
        _result = result;
      }).catch(err => {
        _result = null;
        _err = err;
        this.loadingChangeAccountUserEmailKeyConf = false;
      });

      if(_err){
        this.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(_err));
        this.loadingChangeAccountUserEmailKeyConf = false;
        return;
      }

      // データベースのメールアドレス変更
      _result = null;
      await GraphqlUtil.exec(Mutations.UpdateUserEmail, { email : this.newAccountUserEmail }).then(result => {
        _result = result;
      }).catch(error => {
        _result = null;
        this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        this.loadingChangeAccountUserEmailKeyConf = false;
      });

      if(!_result){
        this.loadingChangeAccountUserEmailKeyConf = false;
        return;
      }

      // 自分のユーザー情報を設定
      this.setUser(_result.data.UpdateUserEmail);

      this.changeAccountUserEmailKeyDialog = false;
      this.changeAccountUserEmailDialog = false;
      this.accountUserEmail = this.newAccountUserEmail;
      this.$refs.changeAccountUserEmailForm.reset();
      this.newAccountUserEmail = "";
      this.$refs.MsgDlg.showSuccess("メールアドレスを変更しました。");
      this.loadingChangeAccountUserEmailKeyConf = false;
    },
    //担当者名変更処理
    changeAccountUserName: async function() {
      //バリデーション
      if (!this.$refs.changeAccountUserNameForm.validate()) {
        return;
      }

      // 現在の担当者名とチェック
      if(this.user.name === this.newAccountUserName){
        this.$refs.MsgDlg.showError("現在の担当者名から変更されていません");
        return;
      }
      //ボタン無効化
      this.loadingChangeAccountUserName = true;

      // データベースの担当者名更新
      let _result = null;
      await GraphqlUtil.exec(Mutations.UpdateUserDisp, { user_disp : this.newAccountUserName }).then(result => {
        _result = result;
      }).catch(error => {
        _result = null;
        this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        this.loadingChangeAccountUserName = false;
      });

      if(!_result){
        this.loadingChangeAccountUserName = false;
        return;
      }

      // 自分のユーザー情報を設定
      this.setUser(_result.data.UpdateUserDisp);

      this.changeAccountUserNameDialog = false;
      this.accountUserName = this.newAccountUserName;
      this.$refs.changeAccountUserNameForm.resetValidation();
      this.newAccountUserName = "";
      this.$refs.MsgDlg.showSuccess("担当者名を変更しました。");
      this.loadingChangeAccountUserName = false;
    },
    // パスワード変更画面 開く
    openChangeUserPasswordDialog: function() {
      let _this = this;
      _this.changeUserPasswordDialog = true;
      // ユーザ名と同じパスワードを指定できないように値を渡す
      // パスワード変更画面を開く時点ではパスワード入力パーツがないので、1秒遅らせて実行
      setTimeout(() => {
        _this.$refs.CreatePasswordField.setUserId(_this.user.cognito_user_name);
      }, 1000);
    },
    //パスワード変更処理
    changeUserPassword : async function(){
      if(await this.checkChangeUserPassword()){
        //ボタン無効化
        this.loadingChangeUserPassword = true;
        // 新旧パスワードを入力してパスワード変更を実施
        let _this = this;
        const user = await Amplify.Auth.currentAuthenticatedUser();
        await Amplify.Auth.changePassword(
          user, 
          _this.beforeChangePassword,
          _this.$refs.CreatePasswordField.getPassword(),
        ).then(async () => {
          // パスワード変更完了API実行
          let _result = null;
          await GraphqlUtil.exec(Mutations.UpdateUserPasswordComplete, null).then(result_tmp => {
            _result = result_tmp;
            Logger.log(result_tmp);
          }).catch(() => {
            // パスワード変更完了APIはメール送信をするだけなので、失敗したとしても
            // cognito上パスワード変更は成功しています。わざとエラーをユーザに表示しません。
            _result = true;
          });
          
          if(_result){
            // パスワード変更成功
            _this.changeUserPasswordDialog = false;
            _this.$refs.MsgDlg.showSuccess("パスワードを変更しました。");
            _this.$refs.changeUserPasswordForm.reset();
            _this.loadingChangeUserPassword = false;
          }
        }).catch(() => {
          _this.$refs.MsgDlg.showError("正しい現在のパスワードを入力してください。");
          _this.loadingChangeUserPassword = false;
        });
      }
    },
    //パスワード変更確認ロジック
    checkChangeUserPassword : async function(){
      var newChangePassword = this.$refs.CreatePasswordField.getPassword();
      var newChangePassword2 = this.$refs.PasswordField.getPassword();
      if(this.beforeChangePassword === ""){
        this.$refs.MsgDlg.showError("現在のパスワードを入力してください");
        return false;
      }
      if(newChangePassword === null){
        this.$refs.MsgDlg.showError("新しいパスワードを入力してください");
        return false;
      }
      if(newChangePassword === this.beforeChangePassword){
        this.$refs.MsgDlg.showError("現在のパスワードから変更されていません");
        return false;
      }
      if(newChangePassword2 === ""){
        this.$refs.MsgDlg.showError("新しいパスワード確認を入力してください");
        return false;
      }
      if(newChangePassword !== newChangePassword2){
        this.$refs.MsgDlg.showError("パスワードとパスワード確認には同じパスワードを入力してください");
        return false;
      }

      // 念のためユーザー情報を再取得
      await this.appSyncGetUser();
      if(newChangePassword === this.user.cognito_user_name){
        this.$refs.MsgDlg.showError("ユーザーIDと同じパスワードは入力不可です");
        // ユーザ名と同じパスワードを指定できないように値を渡す
        this.$refs.CreatePasswordField.setUserId(this.user.cognito_user_name);
        this.$refs.CreatePasswordField.setUserIdNg();
        return false;
      }
      return true;
    },
    //顧問先一覧を生成/更新
    createCompanyList: async function() {
      this.firstCompanies = [];
      var obj = null;
      for (var c = 0; c < this.companies.length; c++) {
        this.firstCompaniesObj.id = this.companies[c].id;
        this.firstCompaniesObj.name = this.companies[c].name;
        obj = Object.assign({},this.firstCompaniesObj);
        this.firstCompanies.push(obj);
      }
      this.$refs.userMainte.setCompany("");
    },
    //フォルダから顧問先招待時の初期値設定
    createFirstCompany: async function(item){
      //顧問先一覧を最新化
      await this.createCompanyList();
      this.$refs.userMainte.setCompany(item.id);
    },
    
    //ファイルドラッグ＆ドロップ処理
    onDrop: function(event) {
      let fileList = event.target.files
        ? event.target.files
        : event.dataTransfer.files;

      for (let i = 0; i < fileList.length; i++) {
        var file = fileList[i];
        //ピリオドが含まれない または ファイルサイズ0の場合はアップロードファイルに含まない
        if(!(/\./.test(file.name)) || file.size === 0){
          continue;
        }
        if(this.detailDialog){
          this.uploadFilesMessage.push(file);
        }else if(this.newIraiDialog){
          this.uploadFiles.push(file);
        }
      }
    },
    doUpload: async function(args, uploadFiles) {

      let _this = this;
      // ファイルアップロード対象チェック
      if(uploadFiles.length === 0){
        return true;
      }

      // ファイル件数分ループ
      let allfilesize = 0;
      for (let i = 0; i < uploadFiles.length; i++) {
        allfilesize += uploadFiles[i].size;
      }

      // プログレスバーを表示
      _this.progressSnackbar = true;
      _this.progressLinearValue = 1;
      _this.progressLinearColor = "light-blue";
      _this.progressMessage = 'ファイルアップロード中です・・・・';

      let uploadedfilesize = 0;
      let okfiles = [];
      let errorfiles = [];
      let uploadStartTime = null;
      let uploadEndTime = null;
      let upBytePerSec = null;
      for (let i = 0; i < uploadFiles.length; i++) {
        args.disp_num = (i + 1); // 表示順は1から開始

        // 転送速度チェック
        if(upBytePerSec){
          // アップロード中でもプログレスバーをすすめる
          let limitsize =  uploadedfilesize + uploadFiles[i].size;
          let uploadedfilesizeTmp = uploadedfilesize;
          setInterval(() => {
            // プログレスバーを可能な限りすすめる
            if(uploadedfilesizeTmp <= limitsize){
              uploadedfilesizeTmp += upBytePerSec;
              var tmpValue = Math.round(uploadedfilesizeTmp / allfilesize * 100);
              if(tmpValue < 100){
                _this.progressLinearValue = tmpValue;
              } else if(tmpValue <= 100){
                _this.progressLinearValue = 100;
                _this.progressMessage = 'ファイルアップロードが完了しました。';
              }
            }
          }, 1000);
        }

        uploadStartTime = (new Date()).getTime();
        await _this.doUploadCore(args, uploadFiles[i]).then(result => {
          okfiles.push(result);
          uploadEndTime = (new Date()).getTime();
        }).catch(error => {
          errorfiles.push(uploadFiles[i]);
          // プログレスバーをエラー用の色に変更
          _this.progressLinearColor = "deep-orange";
          _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
          uploadEndTime = null;
        });

        // 実際のファイルアップロード時刻から転送速度の目安算出
        if(uploadEndTime){
          upBytePerSec = uploadFiles[i].size / ((uploadEndTime - uploadStartTime) / 1000);
        }

        // 成功、失敗にかかわらずアップロードサイズに追加
        uploadedfilesize += uploadFiles[i].size;

        // プログレスバーをすすめる
        var tmpValue = Math.round(uploadedfilesize / allfilesize * 100);
        if(tmpValue < 100){
          _this.progressLinearValue = tmpValue;
        } else if(tmpValue <= 100){
          _this.progressLinearValue = 100;
          _this.progressMessage = 'ファイルアップロードが完了しました。';
        }

      }

      // 少し時間をおいて プログレスバーを非表示
      _this.progressLinearValue = 100;
      _this.progressMessage = 'ファイルアップロードが完了しました。';

      setTimeout(() => {
        _this.progressSnackbar = false;
      }, 1000);
    },
    doUploadCore: async function(args, uploadFile) {

      let uploadResult = null;

      // 重複アップロードを防ぐため、クライアントでID生成
      let key = Uuid.getUuid();
      let fold_id = null;
      let msg_id = args.msg_dtl_id;

      // 署名つきURL取得
      let upload_url = null;
      await GraphqlUtil.exec(Queries.GetUploadSignedUrl,  { key: key, fold_id: fold_id, msg_id: msg_id }).then(result => {
        upload_url = result.data.GetUploadSignedUrl.url;
      }).catch(() => {
        upload_url = null;
      });

      // ファイルアップロード用URLが発行されているかチェック
      if(upload_url){
        // メッセージに紐づくファイルをデータ書き込み
        const createFileInput = {
          file_id: key, // ファイルのキーと同じuuid 
          req_dtl_id: msg_id,  
          disp_num: args.disp_num, 
          name: uploadFile.name,
          size: uploadFile.size,
          disp_size: FileSize(uploadFile.size),
          file_type_cl: uploadFile.type,
        };
        await GraphqlUtil.exec(Mutations.CreateFile, {input: createFileInput}).then(result => {
          uploadResult = result;
        }).catch(error => {
          uploadResult = null;
          Logger.log(error);
        });

        if(!uploadResult){
          throw new Error('result is null');
        }

        // ファイルアップロード
        await FileUtil.upload(upload_url, uploadFile);
      }

      return uploadResult;
    },

    //添付ファイル一覧表示処理
    showFileDownloadDialog : async function(message) {
      let _this = this;
      _this.overlay = true;

      try {
        // 添付ファイル一覧取得 初期表示
        await _this.getFiles(message, true);
      } finally {
        _this.overlay = false;
      }
      // ファイル一覧ポーリング設定 フォーカスがあたっている場合に再起動
      _this.startGetFilesPollingArgs = message;
      window.addEventListener('focus', _this.startGetFilesPolling);
      window.addEventListener('blur',  _this.stopGetFilesPolling);

      setTimeout(() => {
        // ポーリング開始
        _this.startGetFilesPollingArgs = message;
        _this.startGetFilesPolling();
      }, 10000); // 初回は10秒後に起動
    },
    checkGetFilesPolling: function() {
      // 配列がない場合もファイル一覧取得前にポーリング画面を開いた可能性を考慮し、
      // ポーリングを続行
      if(this.fileListMessage.length === 0){
        return true;
      }

      // 添付ファイル一覧取得ポーリングを続けるかチェック
      for (var i = 0; i < this.fileListMessage.length; i++) {
          var fileData = this.fileListMessage[i];
          // ウィルスチェック中、アップロード中が存在するならポーリングを続ける
          if(fileData.virusCheckState === Constant.VirusCheckState.Yet || fileData.virusCheckState === Constant.VirusCheckState.Uploading){
            return true;
          }
      }
      return false;
    },
    // 添付ファイル一覧取得ポーリング開始
    startGetFilesPolling: function() {
      let _this = this;
      let message = _this.startGetFilesPollingArgs; // AddEventListenerから呼び出すため、引数をthisで受け渡す

      // ポーリングを続けるかチェック
      if(_this.checkGetFilesPolling()){
        // 別画面からのフォーカス遷移の場合もあるので、すぐに取得
        _this.getFiles(message, false);
        if(!_this.getFilesInterval){
          // 添付ファイル一覧取得開始
          _this.getFilesInterval = setInterval(() => {
            // ポーリングを続けるかチェック
            if(_this.checkGetFilesPolling()){
              _this.getFiles(message, false);
            } else {
              _this.stopGetFilesPolling();
            }
          }, 10000); // 添付ファイル一覧取得の間隔を10秒に指定
        }
      }
    },
    // 添付ファイル一覧取得ポーリング終了
    stopGetFilesPolling: function() {
      if(this.getFilesInterval){
        clearInterval(this.getFilesInterval)
      }
      this.getFilesInterval = null;
    },
    //添付ファイル一覧取得と表示処理
    getFiles : async function(message, initFlg) {
      // 依頼明細のファイル一覧取得
      let _this = this;

      // ウィルスチェック中のロード中アイコンを5秒ほど表示
      setTimeout(() => {
        _this.virusChecking = true;
        setTimeout(() => {
          _this.virusChecking = false;
        }, 5000);
      }, 1);

      await GraphqlUtil.exec(Queries.GetFiles, { 
        req_dtl_id: message.messageFileListId
      }).then(result => {
        // 取得成功したファイル一覧を画面設定
        // 初期化
        _this.virusCheckFlg = false;
        _this.showImgListFlg = false;
        _this.fileListMessage = []; // 開くたびにデータが増えないように初期化
        for (var i = 0; i < result.data.GetFiles.length; i++) {
          var file = result.data.GetFiles[i];
          const fileData = {
            fileId: file.uuid,
            filename: file.name,
            size: file.disp_size,
            size_byte: file.size, // 一括ダウンロードのゲージ計算用に記憶しておく 画面で使用する必要なし
            uploadUser: message.messageOwner,
            uploadDate: message.messageDatetime,
            iraiTitle: message.messageIraiTitle,
            fileType: file.file_type_cl,
            virusCheckState: file.virus_check_state,
          }
          _this.fileListMessage.push(fileData);
          //ウィルスチェックOK以外が一件でもあれば一括DL不可にするフラグ設定
          if(this.virusCheckFlg === false && fileData.virusCheckState !== Constant.VirusCheckState.Ok){
            this.virusCheckFlg = true;
          }
          //画像一覧表示ボタン表示フラグ
          if(this.showImgListFlg === false && FileUtil.isDispImageFiletype(file.file_type_cl)){
            this.showImgListFlg = true;
          }
        }
        // 初回起動チェック
        if(initFlg){
          // ダイアログ画面を表示
          this.fileDownloadDialog = true;
        }
      }).catch(error => {
        // エラー処理
        Logger.log(error);
        _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
      });
    },
    downloadFile : async function(fileId, messageShowFlg) {
      let _this = this;
      let fileInfo = null;
      _this.loadingFileDownload = true;
      await GraphqlUtil.exec(Queries.GetDownloadSignedUrl, { 
        key: fileId
      }).then(result => {
        fileInfo = result.data.GetDownloadSignedUrl;
      }).catch(error => {
        // エラー処理
        Logger.log(error);
        _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        _this.loadingFileDownload = false;
        throw error;
      });

      // ダウンロード実施
      await FileUtil.download(fileInfo).then(() => {
        if(messageShowFlg){
          _this.$refs.MsgDlg.showSuccess("ダウンロードが完了しました。");
        }
      }).catch(error => {
        // エラー処理
        Logger.log(error);
        _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        _this.loadingFileDownload = false;
        throw error;
      });
      _this.loadingFileDownload = false;
    },
    // API 一括ダウンロード
    downloadSelectFile : async function(table){
      let cnt = 0;
      let fileList = null;
      let fileIdList = [];
      let downloadAllSizeByte = 0;
      if(table === "message"){
        cnt = this.selectedMessageFiles.length;
        fileList = this.selectedMessageFiles;
      }else if(table === "fileList"){
        cnt = this.selectedFiles.length;
        fileList = this.selectedFiles;
      }else if(table === "shareFileList"){
        cnt = this.selectedShareFiles.length;
        fileList = this.selectedShareFiles;
      }

      // 一括ダウンロード対象件数チェック
      if(cnt === 0){
        this.$refs.MsgDlg.showError("一括ダウンロード対象のファイルを選択してください。");
        return;
      }
      
      //ローディング表示
      this.loadingFileDownload = true;

      // ダウンロード用にデータ成形
      for (var i = 0; i < fileList.length; i++) {
        fileIdList.push(fileList[i].fileId);
        downloadAllSizeByte += parseInt(fileList[i].size_byte);
      }

      // プログレスバーを表示
      let _this = this;
      _this.progressSnackbar = true;
      _this.progressLinearValue = 1;
      _this.progressLinearColor = "light-blue";
      _this.progressMessage = 'ファイルダウンロード中です・・・・';

      // プログレスバー 描画関数を定義
      const drowFunc = function(parsent){
        if(parsent < 100){
          _this.progressLinearValue = parsent;
        }
        else if(parsent <= 100){
          _this.progressLinearValue = 100;
          _this.progressMessage = 'ファイルダウンロードが完了しました。';
        }
      }

      // zipダウンロード実行
      await FileUtil.downloadZip(fileIdList, downloadAllSizeByte, drowFunc).then(() => {
        _this.$refs.MsgDlg.showSuccess("一括ダウンロードが完了しました。");
      }).catch(error => {
        // エラー処理
        Logger.log(error);
        // プログレスバーをエラー用の色に変更
        _this.progressLinearColor = "deep-orange";
        // プログレスバーを少し遅れて非表示
        setTimeout(() => {
          _this.progressSnackbar = false;
          _this.loadingFileDownload = false;
        }, 3000);
        this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        throw error;
      });

      // プログレスバーを非表示
      _this.progressSnackbar = false;
      _this.loadingFileDownload = false;
    },

    //画像一覧表示と表示用リスト生成
    showImgList : async function(table){
      var imgFile = {fileId: null, filename: "", fileType: "", fileSrc: ""};
      var imgFileDefault = {fileId: null, filename: "", fileType: "", fileSrc: ""};

      this.thumImgDialog = true;
      if(table === "message"){
        for(var i = 0; i < this.fileListMessage.length; i++){
          if(FileUtil.isDispImageFiletype(this.fileListMessage[i].fileType)){
            //画像ファイルならimgListへ追加
            imgFile.fileId = this.fileListMessage[i].fileId;
            imgFile.fileType = this.fileListMessage[i].fileType;
            imgFile.filename = this.fileListMessage[i].filename;
            this.imgFileLists.push(imgFile);
            //初期化
            imgFile = Vue.util.extend({}, imgFileDefault);
          }
        }
      }
      var fileUrl = "";
      //画像表示用リストの画像をダウンロードする
      for(i = 0; i < this.imgFileLists.length; i++){
        fileUrl = await this.getImgFileUrl(this.imgFileLists[i].fileId,this.imgFileLists[i].fileType);
        this.imgFileLists[i].fileSrc = fileUrl;
      }
    },
    //画像単一表示用処理
    showSoloImgFile : async function(item){
      this.oriImgDialog = true;
      //URLを取得し反映
      let fileUrl = await this.getImgFileUrl(item.fileId, item.fileType);
      this.soloImgFile = fileUrl;
      this.soloImgFileId = item.fileId;
    },
    showSoloImgFileByThum(fileUrl, fileId){
      //画像一覧から別タブでオリジナル画像表示
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        this.downloadFile(fileId, false)
      }else{
        window.open(fileUrl); 
      }
    },
    catchShowImgError(){
      this.$refs.MsgDlg.showError(Constant.Msg.Unexpected);
    },
    //画像ファイル描画用のURLを取得し返す(Promise)
    getImgFileUrl : async function(fileId, fileType){
      return new Promise(resolve => {
        //fileurlを取得する
        let _this = this;
        GraphqlUtil.exec(Queries.GetDownloadSignedUrl, { 
            key: fileId
          }).then(result => {
            //ファイルをバイナリでダウンロードする
            FileUtil.downloadCore(result.data.GetDownloadSignedUrl).then((result) => {
            //ファイルを描画する
            var blob = new Blob([ result.data ], { type: fileType });

            var options = {canvas: true};
            var fileUrl = "";

            //画像回転判定とURL生成処理
            LoadImage.parseMetaData(
              blob,
              function (data) {
                if(data.exif) {
                  //exifが含まれていれば回転処理
                  options.orientation = data.exif.get('Orientation');
                  LoadImage(
                    blob,
                    async (canvas) => {
                      try{
                        const data = canvas.toDataURL(fileType);
                        // data_url形式をblob objectに変換
                        const blob2 = _this.base64ToBlob(data, fileType);
                        // objectのURLを生成
                        fileUrl = window.URL.createObjectURL(blob2);
                        _this.blobUrlLists.push(fileUrl);
                        //URLを返す
                        resolve(fileUrl);
                      }catch(e){
                        _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(e));
                      }
                    },
                    options
                  );
                }else{
                  //回転なしでそのまま
                  fileUrl = window.URL.createObjectURL(blob);
                  _this.blobUrlLists.push(fileUrl);
                  //URLを返す
                  resolve(fileUrl);
                }
              },
            )

          }).catch(error => {
            // エラー処理
            Logger.log(error);
            _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
            throw error;
          });
        }).catch(error => {
          // エラー処理
          Logger.log(error);
          _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
          throw error;
        });
      });
    },
    base64ToBlob(base64, fileType) {
      const bin = atob(base64.replace(/^.*,/, ''));
      const buffer = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i);
      }
      return new Blob([buffer.buffer], {type: fileType});
    },
    // ファイル一覧テーブル カスタムソート
    fileListMessageCustomSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index.length > 0 && index[0] === "size") {
          // ファイルサイズの表示は文字列なので、隠し項目の数値でソート
          if (!isDesc[0]) {
            return a.size_byte - b.size_byte;
          } else {
            return b.size_byte - a.size_byte;
          }
        } else if (index.length > 0 && index[0] === "filename") {
          // ファイル名で比較
          var sort = !isDesc[0] ? 1 : -1;
          return Util.strCmp(a.filename, b.filename) * sort
        }
      });
      return items;
    },
    //一時ダウンロードした画像ファイルを削除する
    clearImgObjUrls(){
      //画像objを解放する
      for(var i = 0; i < this.blobUrlLists.length; i++){
        window.URL.revokeObjectURL(this.blobUrlLists[i]);
      }
      this.blobUrlLists = [];
    },
    appSyncGetUser : async function () {
      let _this = this;
      // ログイン情報からユーザ情報取得
      await GraphqlUtil.exec(Queries.GetUser, null).then(result => {
        // 自分のユーザー情報を設定
        _this.setUser(result.data.GetUser);
      }).catch(error => {
        Logger.log(error);
      });
    },
    setUser(inputUser) {
      // 自分のユーザー情報を設定
      this.user.id = inputUser.user_id;
      this.user.cognito_user_name = inputUser.user_name;
      // 優先cognitoユーザー名チェック
      if(inputUser.preferred_user_name){
        // 優先cognitoユーザー名を表示
        this.user.cognito_user_name = inputUser.preferred_user_name;
      }
      this.user.name = inputUser.disp_name;
      this.user.auth = parseInt(inputUser.auth_type);
      this.user.email = inputUser.email;
    },
    setMenuItems(){
      if(this.user.type === Constant.UserType.Host) {
        if(this.user.auth === Constant.UserAuthType.Admin){
          this.menuItems = this.menuItemsAdmin;
        }else if(this.user.auth === Constant.UserAuthType.General){
          this.menuItems = this.menuItemsOwn;
        }
      }else if(this.user.type === Constant.UserType.Guest){
        this.menuItems = this.menuItemsPart;
      }
    },
  },
};
</script>



<style>
.v-text-field__slot {
  min-width: 0;
}
.v-timeline-item__body {
  max-width: calc(100% - 50px) !important;
}
.v-timeline::before {
  display: none;
}
.v-timeline-item__divider {
  min-width: 10px !important;
}
.v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse)
  .v-timeline-item:nth-child(odd):not(.v-timeline-item--before)
  .v-timeline-item__body,
.v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse)
  .v-timeline-item--after
  .v-timeline-item__body {
  margin-right: 40px;
}
.v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse)
  .v-timeline-item:nth-child(even):not(.v-timeline-item--after)
  .v-timeline-item__body,
.v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse)
  .v-timeline-item--before
  .v-timeline-item__body {
  margin-left: 40px;
}
.v-timeline--reverse:not(.v-timeline--dense)
  .v-timeline-item:nth-child(even):not(.v-timeline-item--before),
.v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item--after {
  margin-right: 40px;
}
.v-timeline--reverse:not(.v-timeline--dense)
  .v-timeline-item:nth-child(odd):not(.v-timeline-item--after),
.v-timeline--reverse:not(.v-timeline--dense) .v-timeline-item--before {
  margin-left: 40px;
}
.v-treeview-node.v-treeview-node--disabled{
  display:none;
}
#dropzone {
  background-color: #eee;
  border: solid 2px #bbb;
  color: #888;
  min-height: 50px;
  padding: 20px;
  padding-right: 20px;
}
.v-file-input > .v-input__control > .v-input__slot > .v-text-field__slot {
  pointer-events: none;
}
</style>